<template>
  <div>
    <div class="make_loading_modal" v-if="spinning">
      <div class="make_loading_modal_inner">
        <a-spin size="large" />
        <div class="make_loading_modal_text">正在合成中，请稍候...</div>
      </div>
    </div>
    <div class="make">
        <div class="header">
          <div class="logo">深层配音</div>


          <div class="editName" v-show="isEditName">
            <a-input v-model:value="filename" ref="inputRef" :bordered="false" :maxlength="25" style="color:#fff; font-size: 15px;caret-color: #fff;" @blur="finishEditName" @focus="selectAllText"/>
            <!-- <EditOutlined /> -->
          </div>

          <div class="editName" v-show="!isEditName" @click="editNameFoucs">
            <span>{{filename}}</span>
            <EditOutlined />
          </div>

          <!-- <div class="saveDraft" @click="saveDraft">
            <span>保存草稿</span>

          </div> -->

          <div class="save_and_user">

            <a-select
              v-model:value="largeModel"
              size="small"
              class="header_action_btn model_switch"
              :loading="largeModelOptionsLoading"
              :bordered="false"
              popupClassName="model-switch-dropdown"
              :dropdownMatchSelectWidth="400"
              :dropdownAlign="{ offset: [-90, 4] }"
              optionLabelProp="title"
            >
              <a-select-option
                v-for="item in largeModelOptions"
                :key="item.value"
                :value="item.value"
                :title="item.selectedTitle"
              >
                <div class="model_option">
                  <div class="model_option_name">{{ item.name }}</div>
                  <div class="model_option_desc">{{ item.description }}</div>
                </div>
              </a-select-option>
            </a-select>

            <div class="header_action_btn save_draft_btn" type="primary" :loading="saveing" @click="saveDraft">
              <LoadingOutlined v-if="saveing" />
              <span v-else>保存草稿</span>
            </div>

            <div class="header_action_btn user" @click="userCenter">
              <UserOutlined />
              <span class="user_text">{{ isLoginState ? '我的' : '登录' }}</span>
              <span v-if="isLoginState" class="user_dot"></span>
            </div>
          </div>


        </div>
        <div class="operation">
          <div class="pause_group">
            <div class="btn_box pause_main" @click="insertBreathTag(500)">
              <IconFont type="icon-Breath" class="operation_icon light_orange"></IconFont>
              <span>停顿</span>
            </div>
            <div class="pause_shortcuts">
              <div class="pause_shortcut_btn" @click="insertBreathTag(500)">0.5秒</div>
              <div class="pause_shortcut_btn" @click="insertBreathTag(1000)">1秒</div>
              <div class="pause_shortcut_btn" @click="insertBreathTag(1500)">1.5秒</div>
            </div>
          </div>

          <!-- <div class="btn_box" @click="insertContinuityTag">
            <IconFont type="icon-Continuity" class="operation_icon light_orange"></IconFont>
            <span>连读</span>
          </div> -->

          <div class="btn_box" @click="duoyinShowFun">
            <IconFont type="icon-Polyphonic" class="operation_icon light_orange"></IconFont>
            <span>多音字</span>
            <div v-show="duoyinShow" id="selectorContainer" class="selectorContainer"
              @mouseleave="handleMouseleaveDuoyin">
              <div v-for="pinyin in duoyinArr[0]" class="duoyin" :data-value="pinyin" @click="insertPinyinTag">
                {{ pinyin }}
              </div>
              <div class="duoyin_divider"></div>
              <div class="duoyin duoyin_custom" @click="openCustomDuoyinModal">
                + 自定义音
              </div>
            </div>
          </div>

          <div class="btn_box" @click="numberFun">
            <IconFont type="icon-Number" class="operation_icon light_orange"></IconFont>
            <span>数字</span>
          </div>

          <div class="partingLine"></div>

          <div class="btn_box" @click="openBackmusicLibrary()">
            <IconFont type="icon-Music" class="operation_icon light_blue"></IconFont>
            <span class="backmusic">{{ confirmBackmusicInfo.title != undefined ? confirmBackmusicInfo.title : '背景音乐' }}</span>
            <div class="remove_backmusic" @click="removeBackmusic($event)" v-show="confirmBackmusicInfo.title != undefined">
              <CloseCircleOutlined />
            </div>
          </div>

          <div class="btn_box" @click="importContentFile('text')">
            <IconFont type="icon-ImportFile" class="operation_icon light_blue"></IconFont>
            <span>导入文件</span>
          </div>

          <div class="btn_box" @click="importContentFile('audio')">
            <IconFont type="icon-ImportFile" class="operation_icon light_blue"></IconFont>
            <span>提取文案</span>
          </div>

          <div class="btn_box" @click="showModelTip">
            <IconFont type="icon-tip" class="operation_icon light_orange2"></IconFont>
            <span>使用技巧</span>
          </div>
          <!-- <star-outlined />
          <star-filled />
          <star-two-tone two-tone-color="#eb2f96" /> -->
        </div>
        <div class="makeBody">
          <div class="make_left ">
            <div class="editor">

              <div v-show="!isTryPreview" class="tts-mark-editor" ref="editorRef" @input="handleInput"
                @paste.prevent="handlePaste" @keyup="handleKeyup" @keydown="handleKeyDown" @mouseup="handleMouseup"
                :empty="isEditorEmpty" :data-placeholder="'请输入需要配音的内容，粘贴或输入文本内容，最多'+wordCountMax+'字…'"
                contenteditable="true" data-tts-mark-editor="true">

                <p class="tts-content-paragraph"><br></p>

              </div>

              <div v-show="isTryPreview" class="tts-mark-editor tts-mark-editor-preview" ref="editorPreviewRef">
              </div>

            </div>
            <div class="core">
              <div class="word_count">当前字数 <span>{{ wordCount }}</span>/{{wordCountMax}} </div>
              <!-- <div class="backmusic">当前背景音乐:<span>{{ selectBackmusicInfo.id != 0 ? selectBackmusicInfo.title : '无' }} </span></div> -->
              <div class="core_btn trial" @click="audition($event, false)">试听
                <LoadingOutlined v-if="isTryPreview&&soundPaused" />
                <PauseOutlined v-else-if="isTryPreview&&!soundPaused" />
                <CaretRightOutlined v-else />
              </div>
              <div class="core_btn complete" @click="fileSetting">合成 </div>
            </div>
          </div>
          <div :class=" retract? 'mini_make_right' : 'make_right' ">
            <div class="speakerSelect" v-show="settingIndex == -1">
              <div class="speaker_header">
                <div class="selectTxt" v-show="!retract">
                  选择人声
                </div>
                <div class="retractBtn" @click="()=>{retract = !retract}">
                  <VerticalLeftOutlined v-show="!retract" />
                  <VerticalRightOutlined v-show="retract" />
                </div>
                <div class="mini_tip" v-show="retract" @click="()=>{retract = !retract}">
                  展开
                </div>
              </div>

              <div class="speaker_main">
                <div class="tabs" v-show="!retract">
                  <div class="tab" :class="{ active: speakerType == 0}" @click="getSperkerList(0)">全部</div>
                  <div class="tab" :class="{ active: speakerType == 2}" @click="getSperkerList(2)">男声</div>
                  <div class="tab" :class="{ active: speakerType == 3}" @click="getSperkerList(3)">女声</div>
                  <div class="tab" :class="{ active: speakerType == 4}" @click="getSperkerList(4)">儿童</div>
                  <div class="tab" :class="{ active: speakerType == 5}" @click="getSperkerList(5)">我的收藏</div>
                  <div class="tab" :class="{ active: speakerType == 1}" @click="getSperkerList(1)">自定义人声</div>
                </div>

                <div class="speakerList" v-show="!retract">
                  <div class="custom_speaker_btn" v-show="speakerType == 1" @click="customSpeaker()">
                    <UploadOutlined style="font-size: 40px;color: #9c9c9c;margin: 15px;" />
                    <p class="custom_tip">上传自定义人声</p>
                  </div>
                  <div class="speaker_empty" v-if="speakerType == 5 && speakerList.length === 0">
                    暂无我的收藏
                  </div>
                  <div class="speaker" :class="{ active: selectSpeakerInfo.id == item.id}"
                    v-for="(item, index) in speakerList" :key="index" @click="selectSpeaker(item)">
                    <div class="speaker_top">
                      <div
                        v-if="showFavoriteButton(item)"
                        class="favorite_icon"
                        :class="{ active: isFavoriteSpeaker(item) }"
                        @click="toggleFavoriteSpeaker($event, item)"
                      >
                        <StarFilled v-if="isFavoriteSpeaker(item)" />
                        <StarOutlined v-else />
                      </div>
                      <div class="speaker_img">
                        <img :src="srcurl+item.img_url" alt="" v-if="item.img_url" />
                        <img src="../assets/image/speaker1.webp" alt="" v-else />
                      </div>

                      <div class="speaker_intro">
                        <div class="speaker_name">{{item.file_name}}</div>
                        <div class="speaker_tag">
                          特点：{{item.info}}
                        </div>
                      </div>

                      <div class="delete_icon" v-show="speakerType == 1" @click="deleteCustomSpeaker(index, item.id)">
                        <DeleteOutlined />
                      </div>
                    </div>
                    <div class="speaker_bottom">

                      <div class="speaker_info">
                        <div class="speaker_info_item">
                          <span>{{item.speedPCT == undefined? '50' : item.speedPCT}}%</span><br />
                          <span>语速</span>
                        </div>
                        <div class="speaker_info_item">
                          <span>{{item.gainPCT == undefined? '50' : item.gainPCT}}%</span><br />
                          <span>音量</span>
                        </div>
                        <!-- <div class="speaker_info_item">
                          <span>50%</span><br/>
                          <span>音调</span>
                        </div> -->
                      </div>

                      <div class="speaker_btn">
                        <div class="speaker_btn_item playerSpeaker"
                          :style="!backmusicFileOpen && auditionPlayId == item.id ? bgProgressBar : ''"
                          @click="speakerAudition(item)">
                          <!-- 试听固定音频 -->

                          <!-- @click="auditionPlay($event, item.id, srcurl+item.path)"> -->
                          试听
                          <LoadingOutlined v-if="!backmusicFileOpen && auditionPlayId == item.id && auditionLoading" />
                          <PauseOutlined
                            v-else-if="!backmusicFileOpen && auditionPlayId == item.id && ((sound && sound.playing && sound.playing()) || (auditionHowl && auditionHowl.playing && auditionHowl.playing()))" />
                          <CaretRightOutlined v-else />
                        </div>
                        <div class="speaker_btn_item setting" @click="settingSpeaker($event, index)">设置</div>
                      </div>

                    </div>
                  </div>
                  <!-- 底部观察元素 -->
                  <div ref="loaderRef" class="loader">
                    <a-spin v-if="loading" />
                    <div v-if="!hasMore" class="no-more">没有更多数据了</div>
                  </div>

                </div>
                <div class="speakerList" v-show="retract">
                  <div class="speaker" v-for="(item, index) in speakerList" :key="index" @click="selectSpeaker(item)">
                    <div class="speaker_img" :class="{ active: selectSpeakerInfo.id == item.id}">
                      <img :src="srcurl+item.img_url" alt="" v-if="item.img_url" />
                      <img src="../assets/image/speaker1.webp" alt="" v-else />
                    </div>
                    <div class="speaker_name">{{item.file_name}}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="settingSpeaker" v-if="settingIndex != -1">
              <div class="speaker_header" @click="()=>{settingIndex = -1}">
                <div class="retractBtn">
                  <VerticalRightOutlined />
                </div>
                <div class="mini_tip">
                  返回
                </div>
              </div>
              <div class="setting_main">

                <div class="speaker">
                  <div class="speaker_top">
                    <div class="speaker_img">
                      <img :src="srcurl+settingInfo.img_url" alt="" v-if="settingInfo.img_url" />
                      <img src="../assets/image/speaker1.webp" alt="" v-else />
                    </div>

                    <div class="speaker_intro">
                      <div class="speaker_name" v-if="speakerType != 1">{{settingInfo.file_name}}</div>
                      <div class="speaker_name editName speaker_name_editable" v-show="speakerType == 1 && isEditCustomSpeakerName">
                        <a-input
                          v-model:value="settingInfo.file_name"
                          ref="customSpeakerNameInputRef"
                          :maxlength="20"
                          :bordered="false"
                          placeholder="请输入人声名称"
                          @change="activeChangeCustomSpeakerName"
                          @blur="handleCustomSpeakerNameBlur"
                          @focus="selectAllText"
                        />
                      </div>
                      <div class="speaker_name editName speaker_name_editable" v-show="speakerType == 1 && !isEditCustomSpeakerName" @click="editCustomSpeakerNameFocus">
                        <span>{{ settingInfo.file_name }}</span>
                        <LoadingOutlined v-if="customSpeakerNameSaving" />
                        <EditOutlined v-else />
                      </div>
                      <div class="speaker_tag">
                        特点：{{settingInfo.info}}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="speaker_setting_item">
                  <div class="setting_item_title"><span>语速</span>
                    <UndoOutlined style="font-size: 22px;color: #9c9c9c;"
                      @click="()=>{speed_value = 50;mapSpeakerSetting(50,'speed',settingIndex)}" />
                  </div>
                  <a-slider v-model:value="speed_value" :step="2.5" :tooltip-open="true" tooltipPlacement="bottom"
                    @afterChange="mapSpeakerSetting($event,'speed',settingIndex)" />
                </div>
                <div class="speaker_setting_item">
                  <div class="setting_item_title"><span>音量增益</span>
                    <UndoOutlined style="font-size: 22px;color: #9c9c9c;"
                      @click="()=>{gain_value = 50;mapSpeakerSetting(50,'gain',settingIndex)}" />
                  </div>
                  <a-slider v-model:value="gain_value" :step="2.5" :tooltip-open="true" tooltipPlacement="bottom"
                    @afterChange="mapSpeakerSetting($event,'gain',settingIndex)" />
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
      <a-modal v-model:open="customDuoyinOpen" title="自定义音" :maskClosable="false" @ok="confirmCustomDuoyin" @cancel="handleCustomDuoyinCancel">
        <template #footer>
          <div style="text-align: center;">
            <a-button class="customCancel custom_btn" key="back" @click="handleCustomDuoyinCancel">取消</a-button>
            <a-button class="customUpload custom_btn" key="submit" type="primary" @click="confirmCustomDuoyin">完成</a-button>
          </div>
        </template>
        <a-form layout="vertical">
          <a-form-item label="拼音">
            <a-input v-model:value="customDuoyinForm.pinyin" placeholder="例如: da" :maxlength="20" />
          </a-form-item>
          <a-form-item label="声调">
            <a-select v-model:value="customDuoyinForm.tone" placeholder="请选择声调">
              <a-select-option :value="0">0</a-select-option>
              <a-select-option :value="1">1</a-select-option>
              <a-select-option :value="2">2</a-select-option>
              <a-select-option :value="3">3</a-select-option>
              <a-select-option :value="4">4</a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </a-modal>
      <!-- 登录弹窗 -->
      <a-modal v-model:open="loginModalOpen" :footer="null" :maskClosable="false" :closable="!loginLoading" width="420px">
        <template #title>
          <div style="text-align: center; font-weight: 600;">手机号登录</div>
        </template>
        <div class="login_modal_body">
          <a-form layout="vertical">
            <a-form-item label="手机号">
              <a-input
                v-model:value="loginForm.phone"
                :maxlength="11"
                placeholder="请输入11位手机号"
                @input="onPhoneInput"
              />
            </a-form-item>
            <a-form-item label="验证码">
              <a-input
                v-model:value="loginForm.code"
                :maxlength="6"
                placeholder="请输入短信验证码"
              >
                <template #suffix>
                  <a-button
                    type="link"
                    :disabled="smsSending || smsCountdown > 0"
                    @click="sendSmsCode"
                    style="padding: 0;"
                  >
                    {{ smsCountdown > 0 ? `${smsCountdown}s后重发` : '发送验证码' }}
                  </a-button>
                </template>
              </a-input>
            </a-form-item>
            <a-button type="primary" block :loading="loginLoading" @click="handleLogin">登录</a-button>
          </a-form>
        </div>
      </a-modal>
      <!-- 自定义人声上传 -->
      <a-modal v-model:open="customSpeakerOpen" title="" @ok="uploadCustomSpeaker()" :afterClose="handleCancel">
        <template #footer>
          <div style="text-align: center;">
            <a-button class="customCancel custom_btn" key="back" @click="handleCancel">取消</a-button>
            <a-button class="customUpload custom_btn" key="submit" type="primary" :disabled="fileList.length === 0"
              @click="uploadCustomSpeaker()">{{ uploading ? '导入中' : '导入' }}</a-button>
          </div>
        </template>
        <a-upload accept="audio/mp3, audio/wav" :file-list="fileList" :max-count="1" list-type="picture"
          :before-upload="beforeUpload" @remove="handleRemove">
          <div class="uploadContent custom_speaker" v-show="speakerType == 1 && fileList.length === 0">
            <UploadOutlined style="font-size: 60px;color: #9c9c9c;margin: 15px 0px 5px 0px;" />
            <p class="custom_tip">上传待克隆人声</p>
            <p class="custom_tip2"><span style="color: red;">*</span>请上传10-20秒清晰、无杂音待克隆人声音频</p>
            <p class="custom_tip3">支持mp3、wav格式&lt;3MB </p>
          </div>

        </a-upload>
        <div class="custom_speaker_optimize">
          <a-checkbox v-model:checked="speakerOptimize">是否进行音质优化</a-checkbox>
          <div class="custom_speaker_noise_reduction">
            <span>是否进行降噪处理</span>
            <a-radio-group v-model:value="noiseReduction">
              <a-radio :value="true">是</a-radio>
              <a-radio :value="false">否</a-radio>
            </a-radio-group>
          </div>
        </div>
      </a-modal>
      <!-- 文本/音频提取 -->
      <a-modal v-model:open="contentFileOpen" title="" @ok="uploadContentFile($event)" :afterClose="handleCancel">
        <template #footer>
          <div style="text-align: center;">
            <a-button class="customCancel custom_btn" key="back" @click="handleCancel">取消</a-button>
            <a-button class="customUpload custom_btn" key="submit" type="primary" :disabled="fileList.length === 0"
              @click="uploadContentFile($event)">{{ uploading ? contentImportMode.loadingText : contentImportMode.confirmText }}</a-button>
          </div>
        </template>
        <a-upload :accept="contentImportMode.accept" :file-list="fileList" :max-count="1" list-type="picture"
          :before-upload="beforeUpload" @remove="handleRemove">
          <div class="uploadContent import_txtfile" v-show="fileList.length === 0">
            <UploadOutlined style="font-size: 60px;color: #9c9c9c;margin: 15px 0px 5px 0px;" />
            <p class="custom_tip">{{ contentImportMode.title }}</p>
            <p class="custom_tip2"><span style="color: red;">*</span>{{ contentImportMode.tip }}</p>
            <p class="custom_tip3">识别文本会插入光标位置，或覆盖选区</p>
            <p class="custom_tip3">{{ contentImportMode.support }}</p>
          </div>
        </a-upload>
      </a-modal>
      <!-- 合成文件设置 -->
      <a-modal v-model:open="fileSettingOpen" @ok="saveFileSetting" :afterClose="handleCancel" class="fileSettingOpen" :bodyStyle="{padding: '30px 20px 0px 20px'}" width="450px">
        <template #title>
          <div style="display: flex;padding-left: 20px;align-items: center;height: 52px; border-bottom: 1px solid #eff2f4;">合成作品设置</div>
        </template>

        <template #footer>
          <div style="text-align: center;">
            <a-button class="customUpload custom_btn" key="submit" type="primary" @click="saveFileSetting()">确认</a-button>
          </div>
        </template>

        <a-form-item label="作品名称" name="filename">
          <a-input v-model:value="filename" :maxlength="25" style="font-size: 15px;" @blur="activeChangeFilename()" :allowClear="true"/>
        </a-form-item>

        <a-form-item label="作品格式" name="filetype">
          <a-radio-group v-model:value="filetype" name="radioGroup">
            <a-radio value="wav">wav</a-radio>
            <a-radio value="mp3">mp3</a-radio>
          </a-radio-group>
        </a-form-item>
      </a-modal>
      <!-- 背景音乐库 -->
      <a-modal v-model:open="backmusicFileOpen" title="" :afterClose="handleCancel" width="964px">
        <template #footer>
          <div class="backmusic_footer">
            <div class="bgvolume">
              <div class="setting_item_title">
                <span>音量</span>
                <UndoOutlined style="font-size: 22px;color: #9c9c9c;" @click="()=>{bgvolume = 30;bgvolumeChange(30)}" />
              </div>
              <a-slider v-model:value="bgvolume" :step="1" @change="bgvolumeChange"/>
            </div>

            <div class="backmusic_btns">
              <a-button class="customCancel custom_btn" key="back" @click="handleCancel">取消使用</a-button>
              <a-button class="customUpload custom_btn" key="submit" type="primary" @click="confirmBackmusicFile()">使用</a-button>
            </div>
          </div>
        </template>

        <a-tabs v-model:activeKey="musicLibraryActiveKey">
          <a-tab-pane key="0" tab="系统音乐库">
            <div class="music_library" ref="systemMusicListRef" @scroll="handleMusicLibraryScroll(0)" @wheel="handleMusicLibraryWheel(0)">
              <!-- <a-empty
                :image="Empty.PRESENTED_IMAGE_SIMPLE" description="暂无数据">
              </a-empty> -->

              <div class="music_library_item" :style="auditionPlayId == item.id ? bgProgressBar : ''"
                :class="{ active: selectBackmusicInfo.id == item.id}" v-for="(item, index) in musicLibrary" :key="item.id"
                @click="selectBackmusicFile($event, item)">
                <div class="player_icon" @click="auditionPlay($event, item.id, srcurl+item.path)">
                  <LoadingOutlined v-if="backmusicFileOpen && auditionPlayId == item.id && auditionLoading" />
                  <PauseOutlined v-else-if="backmusicFileOpen && auditionPlayId == item.id && auditionHowl && auditionHowl.playing && auditionHowl.playing()" />
                  <CaretRightOutlined v-else />
                </div>
                <div class="music_info">
                  <div class="music_name">{{item.title}}</div>
                  <div class="music_duration">{{new Date(item.voice_duration * 1000).toISOString().substring(14, 19) }}
                  </div>
                </div>
              </div>
              <div ref="systemMusicLoaderRef" class="loader">
                <a-spin v-if="musicLoading" />
                <div v-if="!musicHasMore" class="no-more">没有更多数据了</div>
              </div>
            </div>
          </a-tab-pane>

          <a-tab-pane key="1" tab="自定义音乐库">
            <div class="music_library" ref="customMusicListRef" @scroll="handleMusicLibraryScroll(1)" @wheel="handleMusicLibraryWheel(1)">
              <a-upload accept="audio/mp3, audio/wav" :file-list="fileList" :max-count="1" :before-upload="beforeUpload"
                @change="backmusicUpload" :disabled="uploading">
                <div class="music_library_item" style="background-color: #fff;border: 1px dashed #9c9c9c;">
                  <div class="player_icon">
                    <PlusOutlined />
                  </div>
                  <div class="music_info" v-if="!uploading">
                    <div class="music_name">点击上传本地音乐</div>
                    <div class="music_duration">支持mp3、wav格式，10M以下</div>
                  </div>
                  <div class="music_info" v-else>
                    <div class="music_name">上传中</div>
                  </div>
                </div>
                <template #itemRender="{}">
                </template>
              </a-upload>

              <div class="music_library_item" :style="auditionPlayId == item.id ? bgProgressBar : ''"
                :class="{ active: selectBackmusicInfo.id == item.id}" v-for="(item, index) in musicLibrary" :key="item.id"
                @click="selectBackmusicFile($event, item)" @mouseup="(item)=>{item}">
                <div class="player_icon" @click="auditionPlay($event, item.id, srcurl+item.path)">
                  <LoadingOutlined v-if="backmusicFileOpen && auditionPlayId == item.id && auditionLoading" />
                  <PauseOutlined v-else-if="backmusicFileOpen && auditionPlayId == item.id && auditionHowl && auditionHowl.playing && auditionHowl.playing()" />
                  <CaretRightOutlined v-else />
                </div>
                <div class="music_info">
                  <div class="music_name">{{item.title}}</div>
                  <div class="music_duration">{{new Date(item.voice_duration * 1000).toISOString().substring(14, 19) }}
                  </div>
                </div>
                <div class="delete_icon" @click="deleteCustomBackmusic(index, item.id)">
                  <DeleteOutlined />
                </div>
              </div>
              <div ref="customMusicLoaderRef" class="loader">
                <a-spin v-if="musicLoading" />
                <div v-if="!musicHasMore" class="no-more">没有更多数据了</div>
              </div>
            </div>


          </a-tab-pane>
        </a-tabs>
      </a-modal>
  </div>





</template>

<script setup>

import { ref, onMounted, onBeforeUnmount, computed, nextTick, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex';
import { MenuUnfoldOutlined, EditOutlined, UserOutlined, CaretRightOutlined, LoadingOutlined, PauseOutlined, VerticalLeftOutlined, VerticalRightOutlined, AlertOutlined, UndoOutlined, DeleteOutlined, UploadOutlined, PlusOutlined, CloseCircleOutlined, StarOutlined, StarFilled } from '@ant-design/icons-vue';
import { Modal } from 'ant-design-vue';
import { h } from 'vue';

import { Empty } from 'ant-design-vue';
// const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;

import { message } from 'ant-design-vue';
import { polyphonic } from 'pinyin-pro'
import  axios  from 'axios'
import {Howl} from 'howler';
import { AUTH_EXPIRED_EVENT, clearAuthState, getAccessToken, isAuthExpiredError, setAuthToken } from '@/utils/auth';
import { getApiErrorMessage, getApiResponseErrorMessage } from '@/utils/apiError';
// import { is } from 'core-js/core/object';

const editorRef = ref(null) //编辑器DOM
const editorPreviewRef = ref(null) //预览DOM
const inputRef = ref(null) //文件名输入框

const isEditorEmpty = ref(true) //编辑器是否为空
const isEditName = ref(false) //项目名称是否在编辑状态
const isActiveChange = ref(false) //项目名称是主动编辑过
const isTryPreview = ref(false) //是否正在预览

const retract = ref(false) //界面收起展开
const settingIndex = ref(-1) //设置人声index
const duoyinShow = ref(false) //多音选择
const duoyinArr = ref([]) //多音数组
const customDuoyinOpen = ref(false) //自定义多音弹窗
const customDuoyinForm = ref({
  pinyin: '',
  tone: 1,
})

const wordCount = ref(0)  //当前文档字数
const wordCountMax = ref(10000) //文档字数限制
const sentenceCountMax = ref(100) //分句字数上限

const ttsStartOffset = ref(0) //起始偏移
const requestIndex = ref(0) //请求索引
const requestIndexMax = ref(0) //请求段落段落上限
const requestedCount = ref(0) // 已发起试听请求数
const completedCount = ref(0) // 已完成试听请求数
const failedCount = ref(0) // 试听请求失败数
const canceledCount = ref(0) // 试听请求取消数
const currentIndex = ref(0) //播放队列索引
const audioQueue = ref([]); // tts预览数据数组
const segmentList = ref([]); // 后端分段结果
const segmentCursorIndex = ref(0); // 光标所在分段索引

const sound = ref(null) // 全局的 Howl 实例
const bgsound = ref(null) // 全局的 背景音乐 Howl 实例
const bgvolume = ref(30) // 全局的 背景音乐音量
const soundPaused = ref(true);

const savedRange = ref(null) //选区保存
const previewScrollTop = ref(0) // 试听预览前的滚动位置

// 业务数据
const router = useRouter()
const route = useRoute()
const store = useStore();
const weburl = store.state.weburl;
const srcurl = store.state.srcurl;
const speakerList = ref([]); //人声列表
const favoriteSpeakerIds = ref([]); // 收藏人声id列表（接口返回）
const selectSpeakerInfo = ref(null); //选择的人声
const auditionPlayId = ref(null); //试听人声id
const auditionHowl = ref(null) // 试听的 Howl 实例
const auditionLoading = ref(false); //试听的加载状态
const previewSessionId = ref(0); // 试听会话id，避免已取消请求的旧响应继续入队
const auditionPlaybackSessionId = ref(0); // 静态试听会话id，避免旧音频回调覆盖新状态

const spinning = ref(false); //加载状态
const settingInfo = ref(null); //配置人声
const customSpeakerNameSaving = ref(false); // 自定义人声名称保存中
const isEditCustomSpeakerName = ref(false); // 自定义人声名称编辑状态
const customSpeakerNameInputRef = ref(null); // 自定义人声名称输入框
const originalCustomSpeakerName = ref(''); // 打开设置时的人声原始名称
const speed_value = ref(50); //语速 1 0.5~2
const gain_value = ref(50); //音量增益 0 -20~20
const speakerType = ref(0); //音量增益 0 -20~20
const customSpeakerOpen = ref(false); //自定义人声上传弹窗
const contentFileOpen = ref(false); //文本/音频提取上传弹窗
const contentImportType = ref('text'); // text=导入文件 audio=提取文案
const musicLibrary = ref([]); //背景音乐列表
const musicLibraryActiveKey = ref('0'); //音乐库选项卡索引
const selectBackmusicInfo = ref({'id':0}); //选择的背景音乐
const confirmBackmusicInfo = ref({}); //确认的背景音乐
const backmusicFileOpen = ref(false); //背景音乐上传弹窗
const fileSettingOpen = ref(false); //文件设置弹窗
const filename = ref(''); //文件名
const filetype = ref('wav'); //文件类型
const largeModel = ref(1); // 大模型切换 0=CosyVoice, 1=Index-TTS
const largeModelFallbackOptions = [
  { value: 1, name: 'Index-TTS', description: 'Index-TTS', selectedTitle: '当前模型 Index-TTS' },
  { value: 0, name: 'CosyVoice', description: 'CosyVoice', selectedTitle: '当前模型 CosyVoice' },
];
const largeModelOptions = ref([...largeModelFallbackOptions]); // 大模型切换选项
const largeModelOptionsLoading = ref(false);
const normalizeLargeModelOptions = (list = []) => list
  .map((item) => {
    const value = Number(item?.large_model);
    const name = item?.name || `模型${item?.large_model}`;
    const description = item?.description || item?.name || '';
    return {
      value,
      name,
      description,
      selectedTitle: `当前模型 ${name}`,
    };
  })
  .filter((item) => Number.isFinite(item.value));
const syncLargeModelSelection = () => {
  const optionValues = new Set(largeModelOptions.value.map((item) => item.value));
  if (largeModelOptions.value.length > 0 && !optionValues.has(Number(largeModel.value))) {
    largeModel.value = largeModelOptions.value[0].value;
  }
};
const loadLargeModelOptions = async () => {
  largeModelOptionsLoading.value = true;
  try {
    const response = await axios.get('/v2/user/tts_model/index');
    const list = response?.data?.data;
    if (response?.data?.code === 1 && Array.isArray(list) && list.length > 0) {
      largeModelOptions.value = normalizeLargeModelOptions(list);
      if (largeModelOptions.value.length === 0) {
        largeModelOptions.value = [...largeModelFallbackOptions];
      }
    } else {
      largeModelOptions.value = [...largeModelFallbackOptions];
    }
  } catch (error) {
    largeModelOptions.value = [...largeModelFallbackOptions];
  } finally {
    syncLargeModelSelection();
    largeModelOptionsLoading.value = false;
  }
};
const axiosController = ref(null); //axios控制器

const speakerOptimize = ref(false); //音质优化
const noiseReduction = ref(null); //是否降噪，null 表示用户未选择
const fileList = ref([]); //上传文件列表
const uploading = ref(false); // 上传状态
const saveing = ref(false); //保存状态
const draft_id = ref(0); //草稿id
const remakeSpeakerId = ref(0); //重制人声id
const remakeSpeakerDetailLoading = ref(false); //草稿人声详情加载状态
const remakeSpeakerRestorePending = ref(false); //草稿人声是否待恢复
const remakeSpeakerResolved = ref(false); //草稿人声是否已恢复
const speakerSelectionTouched = ref(false); //用户是否已手动切换人声

const loginModalOpen = ref(false);
const loginLoading = ref(false);
const smsSending = ref(false);
const smsCountdown = ref(0);
const loginToken = ref(getAccessToken());
const isLoginState = computed(() => !!loginToken.value);
const loginForm = ref({
  phone: '',
  code: '',
});
let smsTimer = null;

const clearLoginState = () => {
  clearAuthState(axios);
  loginToken.value = '';
};

const openLoginModalByExpired = () => {
  clearLoginState();
  loginModalOpen.value = true;
};

const handleAuthExpiredEvent = () => {
  openLoginModalByExpired();
};

const loaderRef = ref(null);
const FAVORITE_SPEAKER_TAB = 5;
const isCustomSpeakerItem = (speaker) => Number(speaker?.vcnType) === 1 || Number(speaker?.type) === 1;
const showFavoriteButton = (speaker) => !isCustomSpeakerItem(speaker);
const contentImportMode = computed(() => {
  if (contentImportType.value === 'audio') {
    return {
      accept: 'audio/mp3,audio/wav,.mp3,.wav',
      title: '上传本地音频',
      tip: '请上传需要提取文案的音频文件',
      support: '支持mp3、wav格式<20MB',
      confirmText: '提取',
      loadingText: '提取中',
      maxSize: 20971520,
      emptyMessage: '请先选择音频文件。',
      tooManyMessage: '只能上传一个音频文件。',
      tooLargeMessage: '文件大小不能超过20MB。',
      endpoint: '/v2/user/asr/recognize',
      fieldName: 'audio',
      extraFields: [{ key: 'language', value: 'Chinese' }],
      responseText: (response) => response?.data?.data?.text || '',
    };
  }

  return {
    accept: '.txt',
    title: '上传本地文档',
    tip: '请上传10000字以内纯文本文档',
    support: '支持txt格式<5MB',
    confirmText: '导入',
    loadingText: '导入中',
    maxSize: 5242880,
    emptyMessage: '请先选择文件。',
    tooManyMessage: '只能上传一个文件。',
    tooLargeMessage: '文件大小不能超过5MB。',
    endpoint: '/v2/user/import_text/store',
    fieldName: 'upload_file',
    extraFields: [],
    responseText: (response) => response?.data?.data || '',
  };
});
const isFavoriteSpeaker = (speaker) => favoriteSpeakerIds.value.includes(Number(speaker?.id));
const toggleFavoriteSpeaker = async (event, speaker) => {
  event.stopPropagation();
  if (!showFavoriteButton(speaker)) return;

  const speakerId = Number(speaker?.id);
  if (!Number.isFinite(speakerId)) return;

  try {
    const currentlyFavorite = isFavoriteSpeaker(speaker);
    const response = await axios({
      method: 'post',
      url: currentlyFavorite ? '/v2/user/voice/favorite/cancel' : '/v2/user/voice/favorite',
      data: JSON.stringify({
        voice_id: speakerId,
      })
    });

    if (response?.data?.code !== 1) {
      message.error(response?.data?.msg || '收藏操作失败');
      return;
    }

    const nextFavoriteState = !currentlyFavorite;
    if (nextFavoriteState) {
      favoriteSpeakerIds.value = Array.from(new Set([...favoriteSpeakerIds.value, speakerId]));
      speaker.is_favorite = true;
      message.success(response.data.msg || '已收藏');
    } else {
      favoriteSpeakerIds.value = favoriteSpeakerIds.value.filter((id) => id !== speakerId);
      speaker.is_favorite = false;
      if (speakerType.value === FAVORITE_SPEAKER_TAB) {
        speakerList.value = speakerList.value.filter((item) => Number(item?.id) !== speakerId);
      }
      message.success(response.data.msg || '已取消收藏');
    }

    autoSave();
  } catch (error) {
    if (isAuthExpiredError(error)) {
      return false;
    }
    message.error(getApiErrorMessage(error, '收藏操作失败'));
  }
};
let observer = null;
const page = ref(1);
const hasMore = ref(true); // 是否有更多数据
const loading = ref(false); // 是否正在加载数据

const systemMusicLoaderRef = ref(null);
const customMusicLoaderRef = ref(null);
const systemMusicListRef = ref(null);
const customMusicListRef = ref(null);
let musicObserver = null;
const musicPage = ref(1);
const musicHasMore = ref(true); // 当前Tab背景音乐是否有更多数据
const musicLoading = ref(false); // 当前Tab背景音乐是否正在加载数据
const musicType = ref(0); // 背景音乐当前类型

// 背景音乐按 Tab 独立分页状态
const musicLibraryMap = ref({ 0: [], 1: [] });
const musicPageMap = ref({ 0: 1, 1: 1 });
const musicHasMoreMap = ref({ 0: true, 1: true });
const musicLoadingMap = ref({ 0: false, 1: false });
const musicLoadedMap = ref({ 0: false, 1: false });
const musicScrollTouchedMap = ref({ 0: false, 1: false });
const musicAutoFillCountMap = ref({ 0: 0, 1: 0 });

const CUSTOM_MUSIC_TYPE = 1;
const MAX_MUSIC_AUTO_FILL_PAGES = 3;
const isCustomMusicType = (type) => Number(type) === CUSTOM_MUSIC_TYPE;

const stopMusicPaginationForType = (type) => {
  musicLoadingMap.value[type] = false;
  musicHasMoreMap.value[type] = false;

  if ((Number.parseInt(musicLibraryActiveKey.value, 10) || 0) === type) {
    musicLoading.value = false;
    musicHasMore.value = false;
  }

  if (musicObserver) {
    musicObserver.disconnect();
  }
};

const resetMusicPaginationForType = (type) => {
  musicLibraryMap.value[type] = [];
  musicPageMap.value[type] = 1;
  musicHasMoreMap.value[type] = true;
  musicLoadingMap.value[type] = false;
  musicLoadedMap.value[type] = false;
  musicScrollTouchedMap.value[type] = false;
  musicAutoFillCountMap.value[type] = 0;

  if ((Number.parseInt(musicLibraryActiveKey.value, 10) || 0) === type) {
    musicLibrary.value = [];
    musicPage.value = 1;
    musicHasMore.value = true;
    musicLoading.value = false;
  }
};

const requireLoginForCustomMusic = (type) => {
  if (!isCustomMusicType(type) || isLoggedIn()) return true;

  stopMusicPaginationForType(type);
  if (!loginModalOpen.value) {
    message.warning('请先登录后使用自定义音乐库');
  }
  loginModalOpen.value = true;
  return false;
};

const syncActiveMusicState = (type) => {
  musicType.value = type;
  musicLibrary.value = musicLibraryMap.value[type] || [];
  musicPage.value = musicPageMap.value[type] || 1;
  musicHasMore.value = musicHasMoreMap.value[type] ?? true;
  musicLoading.value = musicLoadingMap.value[type] ?? false;
};

const handleMusicLibraryScroll = (type) => {
  musicScrollTouchedMap.value[type] = true;
};

const musicListHasScrollbar = (type) => {
  const container = getMusicListContainerByType(type);
  if (!container) return true;
  return container.scrollHeight > container.clientHeight + 1;
};

const autoFillMusicListIfNeeded = async (type) => {
  await nextTick();
  const currentType = Number.parseInt(musicLibraryActiveKey.value, 10) || 0;
  if (!backmusicFileOpen.value || currentType !== type) return;
  if (musicLoadingMap.value[type] || !(musicHasMoreMap.value[type] ?? true)) return;

  if (musicListHasScrollbar(type)) {
    musicAutoFillCountMap.value[type] = 0;
    return;
  }

  if (musicAutoFillCountMap.value[type] >= MAX_MUSIC_AUTO_FILL_PAGES) return;

  musicAutoFillCountMap.value[type] += 1;
  backmusicStore(type, { source: 'scroll' });
};

const handleMusicLibraryWheel = (type) => {
  musicScrollTouchedMap.value[type] = true;
  if (musicListHasScrollbar(type)) return;
  if (!backmusicFileOpen.value) return;
  if (musicLoadingMap.value[type] || !(musicHasMoreMap.value[type] ?? true)) return;
  if (!musicLoadedMap.value[type]) return;

  backmusicStore(type, { source: 'scroll' });
};

const normalizeMusicItem = (item) => {
  if (!item || item.id == null) return null;

  const title = item.title || item.name || item.file_name || item.filename;
  const path = item.path || item.music_path || item.file_path;
  if (!title || !path) return null;
  const duration = Number(item.voice_duration ?? item.duration ?? item.audio_duration ?? 0);

  return {
    ...item,
    title,
    path,
    voice_duration: Number.isFinite(duration) ? duration : 0,
  };
};

const normalizeUploadedMusic = (payload) => {
  const data = payload?.data;
  if (!data) return null;

  if (Array.isArray(data)) {
    for (const item of data) {
      const music = normalizeMusicItem(item);
      if (music) return music;
    }
    return null;
  }

  const candidates = [
    data.background_music,
    data.music,
    data.item,
    data,
  ];

  for (const candidate of candidates) {
    const music = normalizeMusicItem(candidate);
    if (music) return music;
  }

  return null;
};

const mergeMusicList = (currentList, nextList) => {
  const seen = new Set();
  return [...currentList, ...nextList]
    .map((item) => normalizeMusicItem(item))
    .filter((item) => {
      if (!item) return false;
      const key = String(item.id);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
};

const prependCustomMusic = (music) => {
  if (!music) return false;

  const customList = musicLibraryMap.value[CUSTOM_MUSIC_TYPE] || [];
  musicLibraryMap.value[CUSTOM_MUSIC_TYPE] = [
    music,
    ...customList.filter((item) => item.id !== music.id),
  ];
  musicLoadedMap.value[CUSTOM_MUSIC_TYPE] = true;

  if ((Number.parseInt(musicLibraryActiveKey.value, 10) || 0) === CUSTOM_MUSIC_TYPE) {
    syncActiveMusicState(CUSTOM_MUSIC_TYPE);
  }

  return true;
};

const bindMusicObserverToActiveTab = () => {
  if (!musicObserver) return;
  musicObserver.disconnect();
  const currentTabType = Number.parseInt(musicLibraryActiveKey.value, 10) || 0;
  if (!requireLoginForCustomMusic(currentTabType)) return;

  const targetRef = currentTabType === 0 ? systemMusicLoaderRef.value : customMusicLoaderRef.value;
  if (targetRef) {
    musicObserver.observe(targetRef);
    return;
  }
  // ant tabs 切换时内容可能异步挂载，下一帧再试一次
  setTimeout(() => {
    const retryRef = currentTabType === 0 ? systemMusicLoaderRef.value : customMusicLoaderRef.value;
    if (retryRef && musicObserver) {
      musicObserver.observe(retryRef);
    }
  }, 0);
}

const getMusicListContainerByType = (type) => type === 0 ? systemMusicListRef.value : customMusicListRef.value;
const recreateMusicObserver = () => {
  if (musicObserver) {
    musicObserver.disconnect();
  }

  const currentTabType = Number.parseInt(musicLibraryActiveKey.value, 10) || 0;
  if (!requireLoginForCustomMusic(currentTabType)) return;

  const rootContainer = getMusicListContainerByType(currentTabType);
  if (!rootContainer) return;

  musicObserver = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting && !musicLoading.value && backmusicFileOpen.value) {
      const currentType = Number.parseInt(musicLibraryActiveKey.value, 10) || 0;
      if (musicScrollTouchedMap.value[currentType]) {
        backmusicStore(currentType, { source: 'scroll' });
      }
    }
  }, {
    root: rootContainer,
    threshold: 0.1,
    rootMargin: '0px 0px 100px 0px'
  });

  bindMusicObserverToActiveTab();
}

const progress = ref(0) // 进度
// 背景样式计算属性
const bgProgressBar = computed(() => ({
  background: `linear-gradient(90deg, #27ad9533 ${progress.value}%, #fff ${progress.value}%)`
}))




// 主动修改项目名称处理
const activeChangeFilename = () => {
  // console.log('activeChangeFilename', filename.value.length);
  if(filename.value.length <= 0){
    filenameInit();
  }
  if(!isActiveChange.value) {
    isActiveChange.value = true;
  }
}

// 粘贴事件处理
const handlePaste = (event) => {
  var clipboardContent = getClipboardContent(event),
    pastedHTML = clipboardContent['text/html'],
    pastedPlain = clipboardContent['text/plain'];

  if (event.clipboardData === undefined && !pastedHTML) {
    // If window.clipboardData exists, but event.clipboardData doesn't exist,
    // we're probably in IE. IE only has two possibilities for clipboard
    // data format: 'Text' and 'URL'.
    //
    // For IE, we'll fallback to 'Text' for text/html
    pastedHTML = pastedPlain;
  }

  if (pastedHTML || pastedPlain) {
    event.preventDefault();

    doPaste(pastedPlain);
  }
}

// 鼠标事件处理 鼠标按键弹起
const handleMouseup = (event) => {
  saveSelectionRange();
}

// 键盘事件处理 键盘按键弹起
const handleKeyup = (event) => {
  saveSelectionRange();
}

// 键盘事件处理 键盘按键按下
const handleKeyDown = (event) => {
  if (event.key !== 'Backspace') return;

  const selection = window.getSelection();
  if (!selection.rangeCount) return;

  const range = selection.getRangeAt(0);
  if (!range.collapsed) return;
  // console.log(range);
  const { startContainer, startOffset } = range;
  const prevNode = findPreviousElement(startContainer, startOffset);

  if (prevNode?.tagName === 'I') {
    event.preventDefault();
    prevNode.remove();
    return;
  }

}

// 输入内容管理 （暂时跟随参考不限制）
const handleInput = (event) => {
  checkEmptyState();
  if (wordCount.value >= wordCountMax.value) {
    event.preventDefault()
    return false;
  }
}
// 标签保留方法
const leaveBasis = () => {
  if(!editorRef.value.querySelector('p')){
    editorRef.value.innerHTML = '<p class="tts-content-paragraph"><br></p>';
  }
}

// 保存选区方法
const saveSelectionRange = () => {
  const selection = window.getSelection();
  if (selection.rangeCount > 0) {
    // savedRange.value = selection.getRangeAt(0).cloneRange();//过度复制
    savedRange.value = selection.getRangeAt(0);//避免过度复制
  }
}
// 跨层级查找前一个元素
const findPreviousElement = (startContainer, startOffset) => {
  // 场景1：光标在文本节点开头
  if (startContainer.nodeType === Node.TEXT_NODE && startOffset === 0) {
    const parent = startContainer.parentNode;
    const index = Array.from(parent.childNodes).indexOf(startContainer);
    return index > 0 ? parent.childNodes[index - 1] : null;
  }

  // 场景2：光标在元素节点内部
  if (startContainer.nodeType === Node.ELEMENT_NODE) {
    return startContainer.childNodes[startOffset - 1] || null;
  }

  return null;
}
/**
 * 检查选中的内容或光标是否在可编辑区域内
 * @return {boolean} 如果在可编辑区域内，返回 true；否则返回 false
 */
const isSelectionInEditableDiv = () => {
  if (savedRange.value) {
    const selection = window.getSelection();
    if (selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      return editorRef.value.contains(range.commonAncestorContainer);
    }
  }
  return false;
}

/**
 * 检查选中的内容是否是数字
 * @return {boolean} 如果选中的内容是数字，返回 true；否则返回 false
 */
const isSelectionNumber = () => {
  if (savedRange.value) {
    const selectedText = savedRange.value.toString().trim();
    return !isNaN(selectedText) && selectedText !== '';
  }
  return false;
}

/**
 * 检查选中的内容是否只包含一个字符
 * @return {boolean} 如果选中内容是单个字符，返回 true (selectedText)；否则返回 false
 */
const isSingleCharacterSelection = () => {
  if (savedRange.value) {
    const selectedText = savedRange.value.toString();
    return selectedText;
  }
  return false;
}

/**
 * 恢复之前保存的选区
 */
const restoreSelection = () => {
  if (savedRange.value) {
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(savedRange.value);
  }
}

// 粘贴板内容前置处理
const getClipboardContent = (event) => {
  var dataTransfer = event.clipboardData,
    data = {};

  if (!dataTransfer) {
    return data;
  }

  // Use old WebKit/IE API
  if (dataTransfer.getData) {
    var legacyText = dataTransfer.getData('Text');
    if (legacyText && legacyText.length > 0) {
      data['text/plain'] = legacyText;
    }
  }

  if (dataTransfer.types) {
    for (var i = 0; i < dataTransfer.types.length; i++) {
      var contentType = dataTransfer.types[i];
      data[contentType] = dataTransfer.getData(contentType);
    }
  }

  return data;
}

// 粘贴板内容处理
const doPaste = (pastedPlain) => {
  var paragraphs,
    validParagraphs,
    html = '',
    p,
    select = 0
    ;
  select = window.getSelection().toString().length;
  if (!pastedPlain || wordCount.value - select >= wordCountMax.value) {
    return;
  }

  pastedPlain = pastedPlain.substring(0, (wordCountMax.value - wordCount.value) + window.getSelection().toString().length)

  paragraphs = pastedPlain.split(/[\r\n]+/g);
  validParagraphs = paragraphs.filter(paragraph => hasMeaningfulPlainText(paragraph));
  if (validParagraphs.length === 0) {
    return;
  }
  // If there are no \r\n in data, don't wrap in <p>
  if (paragraphs.length > 1) {
    for (p = 0; p < validParagraphs.length; p += 1) {
      html += '<p class="tts-content-paragraph">' + htmlEntities(validParagraphs[p]) + '</p>';
    }
  } else {
    html = htmlEntities(validParagraphs[0]);
  }

  insertHTMLCommand(document, html);
  checkEmptyState();
}

// html转义处理
const htmlEntities = (str) => {
  // converts special characters (like <) into their escaped/encoded values (like &lt;).
  // This allows you to show to display the string without the browser reading it as HTML.
  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

const normalizeEditorText = (text) => {
  return String(text || '').replace(/\u00a0/g, ' ').replace(/[\u200B-\u200D\uFEFF]/g, '');
}

const hasMeaningfulPlainText = (text) => {
  return normalizeEditorText(text).trim().length > 0;
}

const hasAuditionNodeContent = (node) => {
  if(hasMeaningfulPlainText(node?.textContent || '')){
    return true;
  }
  const tags = Array.from(node?.querySelectorAll?.('i[data-tts]') || []);
  return tags.some(tag => hasMeaningfulPlainText(tag.getAttribute('data-tts') || '') && tag.getAttribute('data-type') !== 'cursor');
}

const hasAuditionTokensContent = (tokens) => {
  return tokens.some(token => {
    if(token.type === 'text'){
      return hasMeaningfulPlainText(token.content);
    }
    if(token.type === 'i'){
      const tag = token.content;
      return hasMeaningfulPlainText(tag.textContent || '') ||
        (hasMeaningfulPlainText(tag.getAttribute('data-tts') || '') && tag.getAttribute('data-type') !== 'cursor');
    }
    return false;
  });
}

const isCursorToken = (token) => {
  return token?.type === 'i' && token.content?.getAttribute?.('data-type') === 'cursor';
}

const englishSegmentLimit = {
  maxWords: 45,
  maxChars: 260,
}

const englishAbbreviations = new Set([
  'mr', 'mrs', 'ms', 'dr', 'prof', 'sr', 'jr', 'st', 'vs', 'no', 'fig',
])

const getSegmentTokenText = (token) => {
  return token.type === 'text' ? token.content : (token.content.textContent || '');
}

const getTokensText = (tokens) => {
  return tokens.map(getSegmentTokenText).join('');
}

const getTextMetrics = (text) => {
  const normalized = normalizeEditorText(text).trim();
  const cjkMatches = normalized.match(/[\u4e00-\u9fff]/g) || [];
  const englishMatches = normalized.match(/[A-Za-z]+(?:['’-][A-Za-z]+)*/g) || [];
  return {
    cjkChars: cjkMatches.length,
    englishWords: englishMatches.length,
    chars: normalized.length,
    effectiveChars: normalized.replace(/\s+/g, '').length,
  }
}

const getSegmentLanguage = (tokens) => {
  const metrics = getTextMetrics(getTokensText(tokens));
  if(metrics.englishWords > 0 && metrics.cjkChars === 0){
    return 'en';
  }
  if(metrics.englishWords >= Math.max(4, Math.ceil(metrics.cjkChars * 0.6))){
    return 'en';
  }
  return 'zh';
}

const isSegmentOverLimit = (tokens) => {
  if(!hasAuditionTokensContent(tokens)){
    return false;
  }
  const text = getTokensText(tokens);
  const metrics = getTextMetrics(text);
  const language = getSegmentLanguage(tokens);
  if(language === 'en'){
    return metrics.englishWords > englishSegmentLimit.maxWords || metrics.chars > englishSegmentLimit.maxChars;
  }
  return metrics.effectiveChars > sentenceCountMax.value;
}

const canMergeSegmentTokens = (currentTokens, nextTokens) => {
  if(!hasAuditionTokensContent(currentTokens)){
    return true;
  }
  return !isSegmentOverLimit(currentTokens.concat(nextTokens));
}

const isEnglishPeriodBoundary = (text, index) => {
  const prevChar = text[index - 1] || '';
  const nextChar = text[index + 1] || '';
  if(/\d/.test(prevChar) && /\d/.test(nextChar)){
    return false;
  }
  if(prevChar === '.' || nextChar === '.'){
    return false;
  }
  const before = text.slice(0, index);
  const wordMatch = before.match(/([A-Za-z]+)$/);
  const lastWord = wordMatch ? wordMatch[1] : '';
  if(lastWord.length === 1 || englishAbbreviations.has(lastWord.toLowerCase())){
    return false;
  }
  const after = text.slice(index + 1);
  return after.trim() === '' || /^[\s"'”’)\]]/.test(after);
}

const isSentenceBoundary = (text, index) => {
  const char = text[index];
  if(/[。！？；]/.test(char)){
    return true;
  }
  if(/[!?;]/.test(char)){
    return true;
  }
  if(char === '：'){
    return true;
  }
  if(char === ':'){
    const prevChar = text[index - 1] || '';
    const nextChar = text[index + 1] || '';
    return !(/\d/.test(prevChar) && /\d/.test(nextChar));
  }
  if(char === '.'){
    return isEnglishPeriodBoundary(text, index);
  }
  return false;
}

const getSentenceBoundaryEndIndex = (text, index) => {
  let endIndex = index;
  while(endIndex + 1 < text.length && /["'”’)\]]/.test(text[endIndex + 1])){
    endIndex++;
  }
  return endIndex;
}

const splitTokensToSentences = (tokens) => {
  const sentences = [];
  let currentSentence = [];
  const commitSentence = () => {
    if(hasAuditionTokensContent(currentSentence)){
      sentences.push(currentSentence);
    }else if(currentSentence.some(isCursorToken) && sentences.length > 0){
      sentences[sentences.length - 1] = sentences[sentences.length - 1].concat(currentSentence);
    }
    currentSentence = [];
  }

  tokens.forEach(token => {
    if(token.type !== 'text'){
      currentSentence.push(token);
      return;
    }
    const text = token.content || '';
    let lastIndex = 0;
    for(let i = 0; i < text.length; i++){
      if(isSentenceBoundary(text, i)){
        const boundaryEndIndex = getSentenceBoundaryEndIndex(text, i);
        const part = text.slice(lastIndex, boundaryEndIndex + 1);
        if(part){
          currentSentence.push({ type: 'text', content: part });
        }
        commitSentence();
        lastIndex = boundaryEndIndex + 1;
        i = boundaryEndIndex;
      }
    }
    const remaining = text.slice(lastIndex);
    if(remaining){
      currentSentence.push({ type: 'text', content: remaining });
    }
  });

  commitSentence();
  return sentences;
}

const splitTextIntoWeakPieces = (text) => {
  const pieces = [];
  let buffer = '';
  Array.from(text || '').forEach(char => {
    buffer += char;
    if(/[\s,，、;；:：!?！？-]/.test(char)){
      pieces.push(buffer);
      buffer = '';
    }
  });
  if(buffer){
    pieces.push(buffer);
  }
  return pieces;
}

const getHardSplitLimit = (language) => {
  return language === 'en' ? englishSegmentLimit.maxChars : sentenceCountMax.value;
}

const findHardSplitIndex = (text, limit) => {
  const safeLimit = Math.max(1, limit);
  const target = Math.min(text.length, safeLimit);
  const head = text.slice(0, target);
  const breakIndexes = [' ', '\n', '\t', ',', '，', '、', ';', '；', ':', '：', '-', '!', '！', '?', '？']
    .map(char => head.lastIndexOf(char));
  const breakIndex = Math.max(...breakIndexes);
  return breakIndex > target * 0.5 ? breakIndex + 1 : target;
}

const splitLongSentenceTokens = (sentenceTokens) => {
  if(!isSegmentOverLimit(sentenceTokens)){
    return [sentenceTokens];
  }

  const language = getSegmentLanguage(sentenceTokens);
  const chunks = [];
  let currentTokens = [];
  const commitChunk = () => {
    if(hasAuditionTokensContent(currentTokens)){
      chunks.push(currentTokens);
    }
    currentTokens = [];
  }

  const addTextPiece = (piece) => {
    let remaining = piece;
    while(remaining){
      const nextToken = { type: 'text', content: remaining };
      if(hasAuditionTokensContent(currentTokens) && isSegmentOverLimit(currentTokens.concat(nextToken))){
        commitChunk();
        continue;
      }
      if(!hasAuditionTokensContent(currentTokens) && isSegmentOverLimit([nextToken])){
        const splitIndex = findHardSplitIndex(remaining, getHardSplitLimit(language));
        currentTokens.push({ type: 'text', content: remaining.slice(0, splitIndex) });
        commitChunk();
        remaining = remaining.slice(splitIndex);
      }else{
        currentTokens.push(nextToken);
        remaining = '';
      }
    }
  }

  sentenceTokens.forEach(token => {
    if(token.type === 'text'){
      splitTextIntoWeakPieces(token.content).forEach(addTextPiece);
      return;
    }
    if(hasAuditionTokensContent(currentTokens) && isSegmentOverLimit(currentTokens.concat(token))){
      commitChunk();
    }
    currentTokens.push(token);
  });

  commitChunk();
  return chunks;
}

const appendPreviewSpan = (tokens, spanIndex) => {
  let span = document.createElement('span');
  span.className = `tts-lrc lrc-${spanIndex} `;
  span.setAttribute('data-index', spanIndex);

  tokens.forEach(token => {
    if (token.type === 'text') {
      span.appendChild(document.createTextNode(token.content));
    } else if (token.type === 'i') {
      span.appendChild(token.content);
    }
  });

  editorPreviewRef.value.appendChild(span);
}

// 判断是否为edge浏览器
const isEdge = () => {
  return (/Edge\/\d+/).exec(navigator.userAgent) !== null
}

// 粘贴事件插入HTML（替换选区，粘贴选区跨标签逻辑）
const insertHTMLCommand = (doc, html) => {
  var selection, range, el, fragment, node, lastNode, toReplace,
    res = false,
    ecArgs = ['insertHTML', false, html];

  /* Edge's implementation of insertHTML is just buggy right now:
    * - Doesn't allow leading white space at the beginning of an element
    * - Found a case when a <font size="2"> tag was inserted when calling alignCenter inside a blockquote
    *
    * There are likely other bugs, these are just the ones we found so far.
    * For now, let's just use the same fallback we did for IE
    */
  if (!isEdge() && doc.queryCommandSupported('insertHTML')) {
    try {
      return doc.execCommand.apply(doc, ecArgs);
    } catch (ignore) { }
  }

  selection = doc.getSelection();
  if (selection.rangeCount) {
    range = selection.getRangeAt(0);
    toReplace = range.commonAncestorContainer;

    // 避免在IE11中在编辑器中粘贴内容时，Medium-Editor 本身将从 DOM 中删除
    // https://github.com/yabwe/medium-editor/issues/748
    // If the selection is an empty editor element, create a temporary text node inside of the editor
    // and select it so that we don't delete the editor element
    if (isMediumEditorElement(toReplace) && !toReplace.firstChild) {
      range.selectNode(toReplace.appendChild(doc.createTextNode('')));
    } else if ((toReplace.nodeType === 3 && range.startOffset === 0 && range.endOffset === toReplace.nodeValue.length) ||
      (toReplace.nodeType !== 3 && toReplace.innerHTML === range.toString())) {
      // Ensure range covers maximum amount of nodes as possible
      // By moving up the DOM and selecting ancestors whose only child is the range
      while (!isMediumEditorElement(toReplace) &&
        toReplace.parentNode &&
        toReplace.parentNode.childNodes.length === 1 &&
        !isMediumEditorElement(toReplace.parentNode)) {
        toReplace = toReplace.parentNode;
      }
      range.selectNode(toReplace);
    }
    range.deleteContents();

    el = doc.createElement('div');
    el.innerHTML = html;
    fragment = doc.createDocumentFragment();
    while (el.firstChild) {
      node = el.firstChild;
      lastNode = fragment.appendChild(node);
    }
    range.insertNode(fragment);

    // Preserve the selection:
    if (lastNode) {
      range = range.cloneRange();
      range.setStartAfter(lastNode);
      range.collapse(true);
      MediumEditor.selection.selectRange(doc, range);
    }
    res = true;
  }

  // https://github.com/yabwe/medium-editor/issues/992
  // If we're monitoring calls to execCommand, notify listeners as if a real call had happened
  if (doc.execCommand.callListeners) {
    doc.execCommand.callListeners(ecArgs, res);
  }
  return res;
}

// 检测是否为可编辑元素 避免在某些浏览器上删除编辑器本身
const isMediumEditorElement = (element) => {
  return element && element.getAttribute && !!element.getAttribute('data-tts-mark-editor');
}

// 检测是否为空
const checkEmptyState = () => {
  let textContent = editorRef.value.innerText;
  textContent = normalizeEditorText(textContent).replace(/\s+/g, ' ').trim();
  // console.log(textContent.length);
  wordCount.value = textContent.length;
  isEditorEmpty.value = wordCount.value === 0;
  if (wordCount.value === 0) {
    leaveBasis();
  }
}

const hasMeaningfulNodeContent = (node) => {
  if (!node) {
    return false;
  }
  if (node.nodeType === Node.TEXT_NODE) {
    return hasMeaningfulPlainText(node.textContent || '');
  }
  if (node.nodeType === Node.ELEMENT_NODE) {
    const tagName = node.tagName.toLowerCase();
    if (tagName === 'br') {
      return false;
    }
    return hasMeaningfulPlainText(node.textContent || '');
  }
  return false;
}

// 检查试听预览中，光标之后是否还有有效内容
const checkTextAfterCursor = (markerNode, startSegmentElement) => {
  if (!editorPreviewRef.value) {
    return false;
  }

  if (markerNode) {
    let current = markerNode.nextSibling;
    while (current) {
      if (hasMeaningfulNodeContent(current)) {
        return true;
      }
      current = current.nextSibling;
    }
  }

  let sibling = startSegmentElement ? startSegmentElement.nextSibling : null;
  while (sibling) {
    if (hasMeaningfulNodeContent(sibling)) {
      return true;
    }
    sibling = sibling.nextSibling;
  }

  return false;
}
const speakerAudition = async (speaker) => {
  const isSameSpeakerActive = auditionPlayId.value === speaker.id;
  const hasActiveSpeakerPreview = isSameSpeakerActive && (auditionLoading.value || isTryPreview.value || !!sound.value || !!auditionHowl.value);

  // 右侧人声试听再次点击时，统一按“停止当前试听”处理
  if (hasActiveSpeakerPreview) {
    finishPreviewSafely();
    return;
  }

  speakerSelectionTouched.value = true;
  remakeSpeakerRestorePending.value = false;
  selectSpeakerInfo.value = speaker;
  resetAudition();
  const sessionId = previewSessionId.value;
  auditionPlayId.value = speaker.id;
  auditionLoading.value = true;

  // 编辑器有内容时，按与总试听一致的逻辑，从当前光标所在分句开始连续试听到结束
  if (!isEditorEmpty.value) {
    previewScrollTop.value = editorRef.value?.scrollTop || 0;
    insertCursorTag();
    editorPreviewRef.value.innerHTML = null;
    await auditionPreview();
    isTryPreview.value = true;
    restorePreviewScrollPosition();

    const elements = editorRef.value.querySelectorAll('.tts-mark-cursor');
    if (elements.length > 0) {
      elements[0].parentNode.removeChild(elements[0]);
    }

    const marker = editorPreviewRef.value.querySelectorAll('.tts-mark-cursor');
    if (marker.length > 0) {
      const startSegmentElement = marker[0].closest('.tts-lrc');
      var range = document.createRange();
      var selection = window.getSelection();
      const shouldStartFromCursor = checkTextAfterCursor(marker[0], startSegmentElement);
      range.setStartAfter(marker[0]);
      marker[0].parentNode.removeChild(marker[0]);
      range.collapse(true);
      selection.removeAllRanges();
      selection.addRange(range);

      if (shouldStartFromCursor) {
        const startIndex = Number(startSegmentElement?.dataset.index ?? 0);
        ttsStartOffset.value = startIndex;
        segmentCursorIndex.value = startIndex;
        convertToServerFormat(startIndex);
      } else {
        ttsStartOffset.value = 0;
        segmentCursorIndex.value = 0;
        convertToServerFormat(0);
      }
    } else {
      ttsStartOffset.value = 0;
      segmentCursorIndex.value = 0;
      convertToServerFormat(0);
    }
    return;
  }

  // 编辑器为空时，直接播放人声静态资源，不再请求新的试听
  if (!speaker.path) {
    auditionLoading.value = false;
    auditionPlayId.value = null;
    message.warning('当前人声缺少试听资源');
    return;
  }

  progress.value = 0;
  const previewSrc = `${srcurl}${speaker.path}`;
  const speakerId = speaker.id;
  const speakerHowl = new Howl({
    src: [previewSrc],
    loop: false,
    volume: bgvolume.value * 0.01,
    onplay: () => {
      if (sessionId !== previewSessionId.value || auditionPlayId.value !== speakerId) return;
      auditionLoading.value = false;
      requestAnimationFrame(updateProgress);
    },
    onend: () => {
      if (sessionId !== previewSessionId.value || auditionPlayId.value !== speakerId) return;
      auditionLoading.value = false;
      auditionPlayId.value = null;
      auditionHowl.value = null;
      progress.value = 0;
    },
    onstop: () => {
      if (sessionId !== previewSessionId.value || auditionPlayId.value !== speakerId) return;
      auditionLoading.value = false;
      auditionPlayId.value = null;
      auditionHowl.value = null;
      progress.value = 0;
    },
    onloaderror: () => {
      if (sessionId !== previewSessionId.value || auditionPlayId.value !== speakerId) return;
      auditionLoading.value = false;
      auditionPlayId.value = null;
      auditionHowl.value = null;
      progress.value = 0;
      message.error('试听资源加载失败');
    },
    onplayerror: () => {
      if (sessionId !== previewSessionId.value || auditionPlayId.value !== speakerId) return;
      auditionLoading.value = false;
      auditionPlayId.value = null;
      auditionHowl.value = null;
      progress.value = 0;
      message.error('试听资源播放失败');
    },
  });
  auditionHowl.value = speakerHowl;
  auditionHowl.value.play();
}
// 试听重置（内容试听、发声人试听）
const resetAudition = () => {
    previewSessionId.value += 1;
    axiosController.value && axiosController.value.abort(); // 取消上一个请求

    // auditionPlayId.value = 0;
    // auditionLoading.value = false;
    // ttsStartOffset.value = 0 //起始偏移重置,生成预览时会重置
    requestIndex.value = 0 //请求索引重置
    requestIndexMax.value = 0
    requestedCount.value = 0
    completedCount.value = 0
    failedCount.value = 0
    canceledCount.value = 0
    currentIndex.value = 0 //播放队列索引重置
    // currentIndex.value = ref(0) //播放队列索引
    audioQueue.value = []; // tts预览数据数组
    soundPaused.value = true;
    auditionLoading.value = false;
    auditionPlayId.value = null; //试听人声id
    progress.value = 0;
    if(auditionHowl.value){
      auditionHowl.value.stop();
      auditionHowl.value = null;
    }
    if(sound.value){
      sound.value.stop();
      sound.value = null;
    }
    if(bgsound.value){
      bgsound.value.stop();
      bgsound.value = null;
    }
}
// 试听逻辑，根据编辑位置开始试听
const audition = async (event, speech, id) => {
  // console.log(speech);
  if (!hasSelectedSpeaker()) {
    message.warning('请选择人声');
    return false;
  }
  resetAudition();
  if(isTryPreview.value){

    isTryPreview.value = !isTryPreview.value
  }else{
    if (isEditorEmpty.value) {
      // if(speech){
      //   auditionPlayId.value = id;
      //   auditionLoading.value = true;
      //   auditiontoServer(speech, 0);
      // }else{
        message.warning('请输入需要播报文本的内容...');
        return false;
      // }
    }else{
      previewScrollTop.value = editorRef.value?.scrollTop || 0;
      // 插入标记
      insertCursorTag(event);
      // 清空预览区域
      editorPreviewRef.value.innerHTML = null;
      // 依据编辑内容转换试听预览界面
      await auditionPreview();
      // 试听预览展示
      isTryPreview.value = !isTryPreview.value
      restorePreviewScrollPosition();

      // 查找光标标记
      const elements = editorRef.value.querySelectorAll('.tts-mark-cursor');
      if(elements.length > 0){
        elements[0].parentNode.removeChild(elements[0]);
      }

        // 查找预览界面克隆光标标记位置
        const marker = editorPreviewRef.value.querySelectorAll('.tts-mark-cursor');
        if (marker.length > 0) {
          const startSegmentElement = marker[0].closest('.tts-lrc');
          //创建一个新的 Range 对象。
          var range = document.createRange();
          // 获取当前的 Selection 对象
          var selection = window.getSelection();
          const shouldStartFromCursor = checkTextAfterCursor(marker[0], startSegmentElement);
          // 将 range 的开始位置设置在 marker 节点之后。
          range.setStartAfter(marker[0]);
          marker[0].parentNode.removeChild(marker[0]);
          // 将 range 折叠（collapse）到起点位置，使其成为一个空的、无内容的范围。
          range.collapse(true);
          // 清除当前 selection 对象中的所有选区（Range）。这样就可以确保我们的 range 是唯一选区。
          selection.removeAllRanges();
          // 将我们刚才设置好的 range 添加到 selection 中。
          selection.addRange(range);
          // 删除 marker 节点，要开始把预览内容转换为服务器接收的格式

          // console.log(range);
          if(shouldStartFromCursor){
            // 获取光标所在分句DOM，从该分句开头开始试听
            const startIndex = Number(startSegmentElement?.dataset.index ?? 0);
            ttsStartOffset.value = startIndex;
            segmentCursorIndex.value = startIndex;
            convertToServerFormat(startIndex);
          }else{
            ttsStartOffset.value = 0
            segmentCursorIndex.value = 0;
            // 试听光标已在结尾，从头开始试听
            convertToServerFormat(0);
          }
        }else{
          ttsStartOffset.value = 0
          segmentCursorIndex.value = 0;
          // 没有在编辑状态进入预览，从头开始试听
          convertToServerFormat(0);
      }
      autoSave();
    }
  }


};

// 试听预览内容转换为服务器接收的格式
const convertToServerFormat = (index) => {
  if(requestIndex.value - index >= 2 || requestIndex.value >= requestIndexMax.value || isTryPreview.value == false){
    return;
  }
  requestIndex.value = index;
  let tts_html = editorPreviewRef.value.querySelectorAll('.lrc-'+index);
  if(!tts_html.length){
    return;
  }
  let tts_text = processHTMLContent(tts_html[0].innerHTML);
  if(index === ttsStartOffset.value){
    tts_text = tts_text.replace(/^.*?\[cursor\]/, '');
  }
  tts_text = tts_text.replace(/\[cursor\]/g, '').trim();
  if(!tts_text){
    requestIndex.value++;
    convertToServerFormat(requestIndex.value);
    return;
  }
  showActive('activeing',index);
  auditiontoServer(tts_text, index);

  // editorPreviewRef.value.querySelectorAll('.tts-lrc').forEach((item , pIndex) => {
  //   console.log(item);
  //   if(index === pIndex){
  //     item.classList.add('activeing');
  //     let tts_text = processHTMLContent(item.innerHTML);
  //     auditiontoServer(tts_text, index);
  //   }else{
  //     item.classList.remove('activeing');
  //   }

  // });
};

const showActive = (mode,index) => {
  editorPreviewRef.value.querySelectorAll('.tts-lrc').forEach((item , pIndex) => {
    if(index === pIndex){
      item.classList.add(mode);
    }else{
      item.classList.remove(mode);
    }
  });
}

// 试听请求发送
const auditiontoServer = (tts_text, index) => {
  console.log('试听请求发送');
  if(!isActiveChange.value && isTryPreview.value && !auditionPlayId.value){
    // 如果没有主动修改过选区，且不是试听状态，且没有试听人声id
    // 选区变更，重新生成预览
    isActiveChange.value = true;
    filename.value = tts_text.slice(0, 25);
  }

  const sessionId = previewSessionId.value;

  // console.log(selectSpeakerInfo.value);
  // 创建AbortController实例
  axiosController.value = new AbortController();
  var data = JSON.stringify({
    "tts_text": tts_text,
    "prompt_voice_id": selectSpeakerInfo.value.id,
    // "background_music_id": confirmBackmusicInfo.value.id,
    "background_music_id": 0,
    "bg_volume": bgvolume.value*0.01,
    "speed": selectSpeakerInfo.value.speed == undefined? 1 : selectSpeakerInfo.value.speed,
    "gain": selectSpeakerInfo.value.gain == undefined? 0 : selectSpeakerInfo.value.gain,
    "large_model": largeModel.value,
  });
  requestIndex.value++
  requestedCount.value++
  var config = {
    method: 'post',
    url: '/v2/user/trial_listening',
    data : data,
    signal: axiosController.value.signal // 添加中断信号
  };
  axios(config)
  .then(function (response) {
    if (sessionId !== previewSessionId.value) {
      console.log('试听响应已过期，忽略');
      return;
    }
    // console.log(JSON.stringify(response.data));
    if(response.data.code == 1){
      completedCount.value++;
      if(isTryPreview.value || auditionPlayId.value){
        addToQueue(response.data.data);
      }else{
        console.log('已停止预览，数据丢弃！');
      }
    } else {
      failedCount.value++;
      finishPreviewSafely();
      message.error(getApiResponseErrorMessage(response, '试听失败，请稍后重试'));
    }
  })
  .catch(function (error) {
    if (sessionId !== previewSessionId.value) {
      console.log('试听异常已过期，忽略');
      return;
    }
    if (isAuthExpiredError(error)) {
      failedCount.value++;
      finishPreviewSafely();
      return;
    }
    // 判断请求是否被取消
    if (axios.isCancel(error)) {
      canceledCount.value++;
      console.log('请求已取消');
    } else {
      failedCount.value++;
      finishPreviewSafely();
      message.error(getApiErrorMessage(error, '试听失败，请稍后重试'));
    }
  });
}

// 添加音频到队列的函数
const addToQueue = (base64Audio) => {
    // 将 Base64 数据封装为 Data URI，指定正确的 MIME 类型
    const dataURI = 'data:audio/wav;base64,' + base64Audio;
    audioQueue.value.push(dataURI);
    // console.log('音频队列：', audioQueue.value);
    if(currentIndex.value == 0){
      playNext();
    }else{
      console.log('音频已加入队列，非首段播放');
      // 如果当前是暂停状态，且当前试听进度小于队列，则继续播放
      if(soundPaused.value == true && currentIndex.value < audioQueue.value.length){
        console.log('暂停等待后重新处理');
        playNext();
      }
      //否则只加入队列，等待播放即可
    }
}

const finishPreviewSafely = () => {
  previewSessionId.value += 1;
  axiosController.value && axiosController.value.abort();
  isTryPreview.value = false;
  soundPaused.value = true;
  auditionLoading.value = false;
  auditionPlayId.value = null;
  audioQueue.value = [];
  requestIndexMax.value = 0;
  currentIndex.value = 0;
  progress.value = 0;
  if(auditionHowl.value){
    auditionHowl.value.stop();
    auditionHowl.value = null;
  }
  if(sound.value){
    sound.value.stop();
    sound.value = null;
  }
  if(bgsound.value){
    bgsound.value.stop();
    bgsound.value = null;
  }
}

const restorePreviewScrollPosition = async () => {
  await nextTick();
  if (!editorPreviewRef.value) {
    return;
  }
  const maxScrollTop = Math.max(0, editorPreviewRef.value.scrollHeight - editorPreviewRef.value.clientHeight);
  editorPreviewRef.value.scrollTop = Math.min(previewScrollTop.value, maxScrollTop);
}

// 请求和播放处理
const playNext = () => {
  // console.log(lrcIndex.value);
  // console.log(audioQueue.value.length);
  if (currentIndex.value < audioQueue.value.length) {
      // console.log(audioQueue.value[currentIndex.value]);
      // 播放处理
      // 创建 Howler.js 的 Howl 实例
      try {
        progress.value = 0
        sound.value = new Howl({
            src: [audioQueue.value[currentIndex.value]],
            // 可选配置项
            // autoplay: true, // 自动播放
            loop: false, // 循环播放
            onplay: () => {
              // requestIndexMax.value == 0 ，此时为试听
              auditionLoading.value = false;
              if(requestIndexMax.value == 0){
                requestAnimationFrame(updateProgressSpeaker);
              }
              soundPaused.value = false;
              showActive('active',currentIndex.value + ttsStartOffset.value);
              currentIndex.value++;
              // 请求处理下一个
              convertToServerFormat(requestIndex.value);
            },
            onend: () => {
              playNext();
              if(requestIndexMax.value == 0){
                // 试听结束
                bgsound.value && bgsound.value.stop();
                bgsound.value = null;
              }
              progress.value = 0
            },
            onstop: () => {
              progress.value = 0
            },
        });
      } finally {
        if(requestIndexMax.value == 0){
          auditionLoading.value = false;
        }
      }
      // 播放音频
      sound.value.play();
      if(confirmBackmusicInfo.value){
        if(!bgsound.value){
          bgsound.value = new Howl({
            src: [srcurl+confirmBackmusicInfo.value.path],
            // 可选配置项
            volume: bgvolume.value * 0.01,
            autoplay: true, // 自动播放
            loop: true, // 循环播放
          });
        }else if(!bgsound.value.playing()){
          bgsound.value.play();
        }
      }
  }else {
    // 重置索引（如果需要从头开始播放）
    // currentIndex.value = 0;
    // 停止
    soundPaused.value = true;
    // 队列播放完毕，可以根据需要执行其他操作
    if(requestIndexMax.value > 0){
      const total = Math.max(requestIndexMax.value - segmentCursorIndex.value, 0);
      const done = completedCount.value;
      const settled = completedCount.value + failedCount.value + canceledCount.value;
      const inflight = requestedCount.value - completedCount.value - failedCount.value - canceledCount.value;
      if(done >= total || (settled >= total && inflight <= 0)){
        finishPreviewSafely();
        if(done >= total){
          message.success('试听完成。');
        }else{
          message.warning('试听已结束，部分内容未能成功播放。');
        }
      }else if(inflight > 0){
        console.log('等待剩余试听请求完成...');
      }else{
        auditionLoading.value = false;
        bgsound.value && bgsound.value.pause();
        message.warning('试听未完成，请继续试听。');
      }
    }
    // 试听结束
    if(requestIndexMax.value == 0){
      auditionLoading.value = false;
      auditionPlayId.value = null;
      audioQueue.value = [];
      if(!isEditorEmpty.value && !isTryPreview.value){
        message.success('主播试听结束，选中后返回编辑页即可完整试听');
      }

    }
    console.log('音频队列已播放完毕。');


  }

}
// 合成文件类型
const fileSetting = () => {
  if (!hasSelectedSpeaker()) {
    message.warning('请选择人声');
    return false;
  }
  if (isEditorEmpty.value) {
    message.warning('请输入需要播报文本的内容...');
    return false;
  }else{
    fileSettingOpen.value = true;
  }

}
// 合成文件设置
const saveFileSetting = () => {
  fileSettingOpen.value = false;
  if(isTryPreview.value){
    // 如果是试听状态，再次试听结束状态
    audition();
  }
  textToSpeech();
}
// 合成
const textToSpeech = () => {

  // 合成时使用与试听完全一致的本地分段，并用 [enter] 拼接为一段文本发送
  const localSegments = buildLocalSegments();
  if(localSegments.length === 0){
    message.warning('请输入需要播报文本的内容...');
    return;
  }
  let tts_text = localSegments.join('[enter]');
  tts_text = tts_text.replace(/\[cursor\]/g, '');
  // if(!isActiveChange.value){
  //   isActiveChange.value = true;
  //   filename.value = tts_text.slice(0, 25);
  // }
  var data = JSON.stringify({
    "tts_text": tts_text,
    "tts_html": editorRef.value.innerHTML,
    "prompt_voice_id": selectSpeakerInfo.value.id,
    "background_music_id": confirmBackmusicInfo.value ? confirmBackmusicInfo.value.id : 0,
    "bg_volume": bgvolume.value*0.01,
    "speed": selectSpeakerInfo.value.speed == undefined? 1 : selectSpeakerInfo.value.speed,
    "gain": selectSpeakerInfo.value.gain == undefined? 0 : selectSpeakerInfo.value.gain,
    "large_model": largeModel.value,
    "filename": filename.value,
    "audio_format": filetype.value,
  });

  var config = {
    method: 'post',
    url: '/v2/user/text_to_speech',
    data : data
  };
  spinning.value = true;

    axios(config)
    .then(function (response) {
      message.success(response.data.msg);
      // message.success('合成成功');
      // downloadFile(response.data.data);
      downloadFileForUrl(response.data.data.path);
      localStorage.removeItem("ttsRemake");
    })
    .catch(function (error) {
      if (isAuthExpiredError(error)) {
        return false;
      }
      message.error(getApiErrorMessage(error, '语音合成失败'));
    }).finally(() => {
      spinning.value = false;
    });



}

const processHTMLContent = (htmlContent) => {
  // 使用 DOMParser 将 HTML 字符串解析为文档对象
  var parser = new DOMParser();
  var doc = parser.parseFromString(htmlContent, 'text/html');

  // 对文档的 body 部分进行处理
  traverseNode(doc.body);

  // 获取处理后的内容（不包括 <body> 标签）
  var processedContent = doc.body.innerHTML;

  // 返回处理后的内容
  return processedContent;
}

const traverseNode = (node) => {
  // 创建子节点的副本列表，因为在遍历过程中子节点列表可能会改变
  var childNodes = Array.from(node.childNodes);
  for (var i = 0; i < childNodes.length; i++) {
    var child = childNodes[i];
    if (child.nodeType === Node.ELEMENT_NODE) { // 元素节点
      if (child.tagName.toLowerCase() === 'i') {
        // 处理 <i> 标签
        processITag(child);
      } else {
        // 不处理其他元素，但需要递归遍历其子节点
        traverseNode(child);
      }
    } else if (child.nodeType === Node.TEXT_NODE) {
      // 文本节点，不做处理
      // 保持原样
    } else {
      // 其他类型的节点，不处理
    }
  }
}

const processITag = (iElement) => {
  // 提取 data-tts 属性的值
  var dataTTSValue = iElement.getAttribute('data-tts') || '';
  // 移除 data-tts 属性（可选）
  iElement.removeAttribute('data-tts');
  // 获取 <i> 标签内的文本内容
  var innerText = iElement.textContent;
  // 创建新的文本节点，将 data-tts 的值附加在文本后面
  var newText = innerText + dataTTSValue;
  var newTextNode = iElement.ownerDocument.createTextNode(newText);
  // 用新的文本节点替换原来的 <i> 元素
  iElement.parentNode.replaceChild(newTextNode, iElement);
}

// 将编辑器内容转换为纯文本（包含 data-tts 标记）
const buildPlainTtsText = () => {
  if(!editorRef.value){
    return '';
  }
  const clone = editorRef.value.cloneNode(true);
  // 替换 <i> 标记为文本 + data-tts
  const iTags = Array.from(clone.querySelectorAll('i'));
  iTags.forEach(tag => {
    const dataTTSValue = tag.getAttribute('data-tts') || '';
    const innerText = tag.textContent || '';
    const newTextNode = clone.ownerDocument.createTextNode(innerText + dataTTSValue);
    tag.parentNode.replaceChild(newTextNode, tag);
  });
  // 将 <br> 替换为换行
  const brTags = Array.from(clone.querySelectorAll('br'));
  brTags.forEach(br => {
    const newTextNode = clone.ownerDocument.createTextNode('\n');
    br.parentNode.replaceChild(newTextNode, br);
  });
  const paragraphs = Array.from(clone.querySelectorAll('p'));
  if(paragraphs.length > 0){
    return paragraphs.filter(p => hasAuditionNodeContent(p)).map(p => p.textContent || '').join('\n');
  }
  return clone.textContent || '';
}


// insertCursorTag 变更前插入鼠标位置，或选区起始点
const insertCursorTag = (event) => {
  if(event){
    event.preventDefault();
  }
  restoreSelection();
  if (savedRange.value) {
    const range = savedRange.value.cloneRange();
    const tag = createTagElement('i', {
      class: 'tts-mark-cursor',
      'data-tts': '[cursor]',
      'data-label': '[cursor]',
      'data-type': 'cursor',
      'contenteditable': 'false',
      style: ''
    })
    range.insertNode(tag)
    // 清空保存的选区
    savedRange.value = null;
    // 调整光标位置，避免选中内容移除后光标错位
    const newRange = document.createRange();
    newRange.setStartAfter(tag);
    newRange.collapse(true);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(newRange);
    saveSelectionRange();

  }

}

// 核心插入方法
const insertTagAtCursor = (tagName, attributes = {}, text = null) => {
  if (savedRange.value) {
    const range = savedRange.value.cloneRange();
    const tag = createTagElement(tagName, attributes, text)
    // 插入逻辑
    if (range.collapsed) {
      range.insertNode(tag)
    } else {
      if(text !== null) {
        range.deleteContents();
      }
      // 非折叠状态处理流程
      const endRange = document.createRange();
      // 精确获取结束边界点
      endRange.setStart(range.endContainer, range.endOffset);
      endRange.collapse(true);
      // 在选区结束位置插入
      endRange.insertNode(tag);

    }
    // range.insertNode(tag)

    // 清空保存的选区
    savedRange.value = null;

    // 调整光标位置，避免选中内容移除后光标错位
    const newRange = document.createRange();
    newRange.setStartAfter(tag);
    newRange.collapse(true);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(newRange);
  }
}

// 创建带属性的标签元素
const createTagElement = (tagName, attributes, text = null) => {
  const tag = document.createElement(tagName)
  Object.entries(attributes).forEach(([key, value]) => {
    tag.setAttribute(key, value)
  })
  if (text) {
    tag.innerText = text
  }
  tag.setAttribute('contenteditable', 'false') // 防止标签内容被直接编辑
  return tag
}

// 插入停顿标签
const insertBreathTag = (duration = 500, event) => {
  if (event) {
    event.preventDefault();
  }
  restoreSelection();
  if (isSelectionInEditableDiv()) {
    const pauseValue = `[p${duration}]`;
    const pauseLabel = duration === 1000 ? '1秒' : `${duration / 1000}秒`;
    insertTagAtCursor('i', {
      class: 'tts-mark-flag tts-mark-point tts-mark-pause',
      'data-tts': pauseValue,
      'data-label': pauseLabel,
      'data-type': 'pause',
      'contenteditable': 'false',
      style: 'color: #fff;'
    })
    //init
  } else {
    message.warning('请确保光标或选中内容在可编辑区域内');
  }
  // $('#selectorContainerSecond').hide()
  saveSelectionRange();
  return false
}

//insertContinuityTag 插入连读标签
const insertContinuityTag = (event) => {
  event.preventDefault();
  restoreSelection();
  if (isSelectionInEditableDiv()) {
    insertTagAtCursor('i', {
      class: 'tts-mark-flag tts-mark-point tts-mark-continuity',
      'data-tts': '[continuity]',
      'data-label': '连读',
      'data-type': 'continuity',
      'contenteditable': 'false',
      style: 'color: #fff;'
    })
    //init
  } else {
    message.warning('请确保光标或选中内容在可编辑区域内');
  }
  // $('#selectorContainerSecond').hide()
  saveSelectionRange();
  return false
}

// 展示多音选择
const duoyinShowFun = (event) => {
  event.preventDefault();
  restoreSelection();
  if (isSelectionInEditableDiv()) {
    var selectText = isSingleCharacterSelection();
    if (selectText.length === 1) {
      if (/^[\u4e00-\u9fa5]$/.test(selectText)) {
        duoyinArr.value = polyphonic(selectText, { type: 'array', toneType: 'num' })
        duoyinShow.value = true;
      } else {
        message.warning('请选择汉字');
      }
    } else {
      message.warning('请确保仅选择一个字符。');
    }
  } else {
    message.warning('请确保光标或选中内容在可编辑区域内');
  }
}

// 鼠标移出多音选择界面
const handleMouseleaveDuoyin = () => {
  // console.log('handleMouseleaveDuoyin');
  duoyinShow.value = false;
}

// 打开自定义多音弹窗
const openCustomDuoyinModal = (event) => {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }
  customDuoyinForm.value = {
    pinyin: '',
    tone: 1,
  };
  customDuoyinOpen.value = true;
}

const normalizeModelTipContent = (payload) => {
  if (!payload) return '';
  if (typeof payload === 'string') return payload.trim();
  return String(payload).trim();
};

const pickModelTipItem = (data, modelValue) => {
  const list = Array.isArray(data) ? data : [];
  return list.find((item) => Number(item?.large_model) === Number(modelValue)) || list[0] || null;
};

const renderModelTipNodes = (tipItem) => {
  if (!tipItem) {
    return [h('div', { class: 'model_tip_empty' }, '暂无使用技巧')];
  }
  const titleLines = normalizeModelTipContent(tipItem.title).split(/\r?\n/).map((line) => line.trim()).filter(Boolean);
  const contentLines = normalizeModelTipContent(tipItem.content).split(/\r?\n/).map((line) => line.trim()).filter(Boolean);
  const nodes = [];
  if (tipItem.model_name) {
    nodes.push(h('div', { class: 'model_tip_model_name' }, tipItem.model_name));
  }
  if (titleLines.length) {
    nodes.push(h('div', { class: 'model_tip_section_title' }, '使用技巧标题'));
    nodes.push(h('ul', { class: 'model_tip_list' }, titleLines.map((line) => h('li', null, line))));
  }
  if (contentLines.length) {
    nodes.push(h('div', { class: 'model_tip_section_title' }, '使用技巧内容'));
    nodes.push(h('ul', { class: 'model_tip_list' }, contentLines.map((line) => h('li', null, line))));
  }
  if (!nodes.length) {
    nodes.push(h('div', { class: 'model_tip_empty' }, '暂无使用技巧'));
  }
  return nodes;
};

const showModelTip = async () => {
  const modal = Modal.info({
    title: '使用技巧',
    width: 560,
    centered: true,
    okText: '知道了',
    content: h('div', { class: 'model_tip_modal' }, [
      h('div', { class: 'model_tip_loading' }, '正在加载...'),
    ]),
  });

  try {
    const response = await axios.get('/v2/user/model_tip/index', {
      params: { large_model: Number(largeModel.value) },
    });
    if (response?.data?.code === 1) {
      const tipItem = pickModelTipItem(response?.data?.data, Number(largeModel.value));
      modal.update({
        content: h('div', { class: 'model_tip_modal' }, renderModelTipNodes(tipItem)),
      });
      return;
    }
    modal.update({
      content: h('div', { class: 'model_tip_modal' }, [
        h('div', { class: 'model_tip_empty' }, response?.data?.msg || '获取使用技巧失败'),
      ]),
    });
  } catch (error) {
    modal.update({
      content: h('div', { class: 'model_tip_modal' }, [
        h('div', { class: 'model_tip_empty' }, error?.response?.data?.msg || error?.message || '获取使用技巧失败'),
      ]),
    });
  }
};

const handleCustomDuoyinCancel = () => {
  customDuoyinOpen.value = false;
}

const insertCustomPinyinTag = (pinyinText) => {
  restoreSelection();

  if (isSelectionInEditableDiv()) {
    var selectText = isSingleCharacterSelection();
    if (selectText.length === 1) {
      if (isWrappingTagContains('i', { 'data-type': 'pinyin' })) {
        message.warning('选中的内容已经处理过，无法重复处理。请删除处理内容后再尝试。');
      } else {
        insertTagAtCursor('i', {
          class: 'tts-mark-flag tts-mark-point tts-mark-pinyin',
          'data-tts': '[=' + pinyinText + ']',
          'data-label': '[=' + pinyinText + ']',
          'data-type': 'pinyin',
          'contenteditable': 'false',
          style: 'color: #ff0000;cursor: pointer;'
        }, selectText)
      }
    } else {
      message.warning('请确保仅选择一个字符。');
    }
    saveSelectionRange();
  } else {
    message.warning('请确保光标或选中内容在可编辑区域内');
  }

  duoyinShow.value = false;
  customDuoyinOpen.value = false;
}

const confirmCustomDuoyin = () => {
  const pinyin = (customDuoyinForm.value.pinyin || '').trim().toLowerCase();
  const tone = String(customDuoyinForm.value.tone ?? '').trim();

  if (!/^[a-züv]+$/.test(pinyin)) {
    message.warning('请输入合法拼音（仅字母，可包含ü或v）');
    return;
  }

  if (!/^[0-4]$/.test(tone)) {
    message.warning('声调只能是0-4的数字');
    return;
  }

  insertCustomPinyinTag(`${pinyin}${tone}`);
}

// 插入多音字标签
const insertPinyinTag = (event) => {
  // console.log(event.target.innerText);
  event.preventDefault();
  event.stopPropagation();
  restoreSelection();

  if (isSelectionInEditableDiv()) {
    var selectText = isSingleCharacterSelection();
    // console.log(selectText.length);
    if (selectText.length === 1) {
      if (isWrappingTagContains('i', { 'data-type': 'pinyin' })) {
        message.warning('选中的内容已经处理过，无法重复处理。请删除处理内容后再尝试。');
      } else {

        insertTagAtCursor('i', {
          class: 'tts-mark-flag tts-mark-point tts-mark-pinyin',
          'data-tts': '[=' + event.target.innerText + ']',
          'data-label': '[=' + event.target.innerText + ']',
          'data-type': 'pinyin',
          'contenteditable': 'false',
          style: 'color: #ff0000;cursor: pointer;'
        }, selectText)

      }
    } else {
      // console.log(selectText.length);
      message.warning('请确保仅选择一个字符。');
    }
    // 处理完选区后，重新更新选区状态
    saveSelectionRange();
  } else {
    message.warning('请确保光标或选中内容在可编辑区域内');
  }

  duoyinShow.value = false;
}
/**
 * 检测单个字符是否被指定标签直接包裹且包含特定属性及值
 * @param {string} tagName - 目标标签名（不区分大小写）
 * @param {Object} [attributes={}] - 属性和值的键值对，例如 { 'data-type': 'pinyin', class: 'highlight' }
 * @returns {boolean} 检测结果
 */
const isWrappingTagContains = (tagName = 'i', attributes = {}) => {
  const selection = window.getSelection();

  // 验证选区有效性
  if (!selection.rangeCount || selection.isCollapsed) return false;
  const range = selection.getRangeAt(0);
  if (range.startOffset + 1 !== range.endOffset) return false;

  // 获取直接父元素
  const textNode = range.startContainer;
  const parent = textNode.parentElement;
  if (!parent || parent.nodeType !== Node.ELEMENT_NODE) return false;

  // 标签名匹配检测
  const isTagValid = parent.tagName.toLowerCase() === tagName.toLowerCase();
  if (!isTagValid) return false;

  // 属性键值对检测
  const attributeKeys = Object.keys(attributes);
  if (attributeKeys.length === 0) return true; // 无属性要求时直接通过

  return attributeKeys.every(key => {
    const expectedValue = attributes[key];
    const actualValue = parent.getAttribute(key);

    // 严格比较属性值
    return actualValue === expectedValue;
  });
}

// 数字读音处理
const numberFun = (event) => {
  // let secondsToGo = 5;
  const modal = Modal.info({
    title: '请直接将需要朗读的数字和字符号输入为汉字',
    content: '示例110:壹壹零/幺幺零/壹佰壹拾',
    icon: h(AlertOutlined, { // 元素类型
      style: { color: '#27ad95' },
    }, ),
    okText: '知道了',
  });


}


// 经济体量大[=da4]，向[w3]前发[w0]展就[p500]需要更大的推动力。
// <p class="tts-content-paragraph">经济体量<i class="tts-mark-flag tts-mark-point tts-mark-annotation _active" contenteditable="false" data-tts="[=da4]" data-label="[=da4]" data-type="annotation" style="font-size: 15px; font-weight: 400; color: rgb(255, 0, 0);">大</i>，向<i class="tts-mark-flag tts-mark-point tts-mark-segmentation" contenteditable="false" data-tts="[w3]" data-label="换气" data-type="w"></i>前发<i class="tts-mark-flag tts-mark-point tts-mark-continuity" contenteditable="false" data-tts="[w0]" data-label="连读" data-type="w"></i>展就<i class="tts-mark-flag tts-mark-point tts-mark-pause" contenteditable="false" data-tts="[p500]" data-label="0.5秒" data-type="p"></i>需要更大的推动力。</p>


// 按句子切分
const handlePreview1 = () => {

  const paragraphs = editorRef.value.childNodes;
  let globalIndex = 0;
  paragraphs.forEach(p => {
    if(p.nodeName != 'P' || !hasAuditionNodeContent(p)) return;
    // 创建文档片段处理节点
    const fragment = document.createDocumentFragment();
    let currentSpan = null;
    let pendingContent = [];
    const localSpans = [];
    // 递归处理子节点
    const walkNodes = (nodes) => {
      nodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE) {
          processTextNode(node);
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          processElementNode(node);
        }
      });
    };

    // 处理文本节点
    const processTextNode = (textNode) => {
      const text = textNode.textContent;
      // const splitRegex = /([。；;])/g;
      const splitRegex = /([。.；;！!？?])/g; // 增加感叹号和问号
      let lastIndex = 0;
      let match;

      while ((match = splitRegex.exec(text)) !== null) {
        const delimiterIndex = match.index;
        const part = text.slice(lastIndex, delimiterIndex + 1);
        pendingContent.push(document.createTextNode(part));
        commitSpan();
        lastIndex = delimiterIndex + 1;
      }

      // 处理剩余文本
      const remaining = text.slice(lastIndex);
      if (remaining) {
        pendingContent.push(document.createTextNode(remaining));
      }
    };

    // 处理元素节点
    const processElementNode = (element) => {
      pendingContent.push(element.cloneNode(true));
    };

    // 提交当前span
    const commitSpan = () => {
      if (pendingContent.length > 0) {
        currentSpan = document.createElement('span');
        currentSpan.append(...pendingContent);
        localSpans.push(currentSpan);
        pendingContent = [];
      }
    };

    // 开始处理节点
    walkNodes(p.childNodes);
    commitSpan(); // 提交最后一段

    // 分配全局索引
    localSpans.forEach(span => {
      span.className = `tts-lrc lrc-${globalIndex++}`;

      fragment.appendChild(span);
    });

    // 添加换行
    fragment.appendChild(document.createElement('br'));
    editorPreviewRef.value.appendChild(fragment);
  });
}

// 按字数切分（旧逻辑，作为兜底）
const auditionPreviewLegacy = () => {
  const paragraphs = editorRef.value.childNodes;
  let spanIndex = 0;

  paragraphs.forEach((p, pIndex) => {
    if(p.nodeName != 'P') return;
    if(!hasAuditionNodeContent(p)) return;
    const unifiedTokens = [];
    const childNodes = p.childNodes;

    // Create a unified token stream
    childNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        let text = node.textContent;
        unifiedTokens.push({ type: 'text', content: text });
      } else if (node.nodeType === Node.ELEMENT_NODE && node.tagName.toLowerCase() === 'i') {
        unifiedTokens.push({ type: 'i', content: node.cloneNode(true) });
      }
    });

    const sentences = splitTokensToSentences(unifiedTokens).flatMap(splitLongSentenceTokens);
    let currentSpanTokens = [];
    const commitCurrentSpan = () => {
      if (!hasAuditionTokensContent(currentSpanTokens)) {
        currentSpanTokens = [];
        return;
      }
      appendPreviewSpan(currentSpanTokens, spanIndex);
      spanIndex++;
      currentSpanTokens = [];
    }

    sentences.forEach(sentenceTokens => {
      if (!hasAuditionTokensContent(sentenceTokens)) {
        return;
      }
      if (!canMergeSegmentTokens(currentSpanTokens, sentenceTokens)) {
        commitCurrentSpan();
      }
      currentSpanTokens = currentSpanTokens.concat(sentenceTokens);
    });

    commitCurrentSpan();

    // After processing each paragraph, insert a <br> if it's not the last paragraph
    // if (pIndex < paragraphs.length - 1) {
    // console.log(pIndex, paragraphs.length);
    editorPreviewRef.value.appendChild(document.createElement('br'));
    // }

    // Replace the original paragraph with the new content
    // p.parentNode.replaceChild(editorPreviewRef.value, p);
  });

  requestIndexMax.value = spanIndex;
}

// 基于前端本地规则生成分段（用于试听与合成统一）
const buildLocalSegments = () => {
  if(!editorPreviewRef.value || !editorRef.value){
    return [];
  }
  editorPreviewRef.value.innerHTML = '';
  auditionPreviewLegacy();
  const ttsNodes = editorPreviewRef.value.querySelectorAll('.tts-lrc');
  const segments = [];
  ttsNodes.forEach((node) => {
    let seg = processHTMLContent(node.innerHTML || '');
    seg = (seg || '').replace(/\[cursor\]/g, '').trim();
    if(seg){
      segments.push(seg);
    }
  });
  return segments;
}

// 通过前端本地分段（与合成统一）
const auditionPreview = async () => {
  segmentList.value = [];
  segmentCursorIndex.value = 0;

  const localSegments = buildLocalSegments();
  if(localSegments.length === 0){
    throw new Error('分段结果为空');
  }

  segmentList.value = localSegments;
  requestIndexMax.value = localSegments.length;
}


const tts = () => {
  //1 {
  // "param":
  //   {
  //     "text":
  //     "代表对此体会很深：目前江苏的晶硅电池、动力电池等产业在全球\n\n\n\r\n",
  //     "speed": 50,
  //     "pitch": 50,
  //     "vol": 0,
  //     "speakerNo": 674250111,
  //     "vcnType": 4,
  //     "lanType": 1,
  //     "language": "【普通话】"
  //   },
  // "base":
  //   {
  //     "appid": "xfpy",
  //     "sid": "GNGGF77dbUTSQZRJ598Ja7KhPbJ2benZ",
  //     "channelId": "40000001",
  //     "userId": "230215112903419770",
  //     "osid": 0
  //   }
  // }


  //2 {
  // "param":
  //   {
  //     "text": "均有较高市场占有率，实现了全产业链自主可控",
  //     "speed": 50,
  //     "pitch": 50,
  //     "vol": 0,
  //     "speakerNo": 674250111,
  //     "vcnType": 4,
  //     "lanType": 1,
  //     "language": "【普通话】"
  //   },
  // "base":
  //   {
  //     "appid": "xfpy",
  //     "sid": "Glh2T6VMXkLM3PhFGGYdZRJ4FKO8P9P0",
  //     "channelId": "40000001",
  //     "userId": "230215112903419770",
  //     "osid": 0
  //   }
  // }

  //1 {
  //   "sid": "20250310101213937WEZ4I",
  //   "code": 0,
  //   "desc": "成功",
  //   "data": {
  //       "audioRate": 24000,
  //       "audioContent": ""

  //   },
  //   "successful": true
  // }

  //2 {
  //   "sid": "202503101012162757ZWQS",
  //   "code": 0,
  //   "desc": "成功",
  //   "data": {
  //       "audioRate": 24000,
  //       "audioContent": ""

  //   },
  //   "successful": true
  // }

};
const isSameSpeakerId = (left, right) => Number(left) === Number(right);
const hasSelectedSpeaker = () => {
  const speakerId = Number(selectSpeakerInfo.value?.id);
  return Number.isFinite(speakerId) && speakerId > 0;
};
const syncSelectedSpeakerFromList = () => {
  const selectedId = Number(selectSpeakerInfo.value?.id);
  if (Number.isFinite(selectedId) && selectedId > 0) {
    const selectedSpeaker = findSpeakerById(speakerList.value, selectedId);
    if (selectedSpeaker) selectSpeakerInfo.value = selectedSpeaker;
    return;
  }

  selectSpeakerInfo.value = speakerList.value[0] || null;
};
const getSpeedPct = (speed) => {
  const value = Number(speed);
  if (!Number.isFinite(value)) return 50;
  const pct = value >= 1 ? 50 + (value - 1) * 50 : 50 - (1 - value) * 100;
  return Math.min(100, Math.max(0, Math.round(pct)));
};
const getGainPct = (gain) => {
  const value = Number(gain);
  if (!Number.isFinite(value)) return 50;
  const pct = (value + 20) / 0.4;
  return Math.min(100, Math.max(0, Math.round(pct)));
};
const normalizeSpeaker = (item = {}) => {
  const type = Number(item?.type);
  return {
    ...item,
    type: item?.type !== undefined && item?.type !== null && item?.type !== '' && Number.isFinite(type)
      ? type
      : undefined,
    is_favorite: item?.is_favorite === true,
    speedPCT: item?.speedPCT !== undefined ? item.speedPCT : getSpeedPct(item?.speed),
    gainPCT: item?.gainPCT !== undefined ? item.gainPCT : getGainPct(item?.gain),
  };
};
const findSpeakerById = (list = [], speakerId) => list
  .find((speaker) => isSameSpeakerId(speaker?.id, speakerId));
const mergeSpeakerList = (currentList = [], incomingList = []) => {
  const mergedList = currentList.map((item) => normalizeSpeaker(item));
  const indexById = new Map();
  mergedList.forEach((item, index) => {
    const id = Number(item?.id);
    if (Number.isFinite(id)) indexById.set(id, index);
  });

  incomingList.forEach((item) => {
    const normalizedItem = normalizeSpeaker(item);
    const id = Number(normalizedItem?.id);
    if (!Number.isFinite(id)) return;

    const existingIndex = indexById.get(id);
    if (existingIndex === undefined) {
      indexById.set(id, mergedList.length);
      mergedList.push(normalizedItem);
    } else {
      const currentItem = mergedList[existingIndex];
      const mergedItem = {
        ...normalizedItem,
        ...currentItem,
      };
      // 分页里再次返回当前置顶人声时，保留用户本地调过的参数。
      if (normalizedItem.type !== undefined) mergedItem.type = normalizedItem.type;
      mergedList[existingIndex] = mergedItem;
    }
  });

  return mergedList;
};
const syncFavoriteSpeakerIds = () => {
  favoriteSpeakerIds.value = Array.from(new Set([
    ...favoriteSpeakerIds.value,
    ...speakerList.value
      .filter((item) => item?.is_favorite === true)
      .map((item) => Number(item?.id))
      .filter((id) => Number.isFinite(id)),
  ]));
};
const shouldShowSpeakerInTab = (speaker, tab) => {
  if (!speaker || !Number.isFinite(Number(speaker?.id)) || Number(speaker?.id) <= 0) return false;
  if (tab === 0) return true;
  if (tab === FAVORITE_SPEAKER_TAB) return isFavoriteSpeaker(speaker);
  return Number(speaker?.type) === Number(tab);
};
const upsertSpeakerToList = (speaker) => {
  if (!shouldShowSpeakerInTab(speaker, speakerType.value)) return;

  const existingSpeaker = findSpeakerById(speakerList.value, speaker.id);
  const mergedSpeaker = existingSpeaker
    ? { ...existingSpeaker, ...speaker }
    : speaker;
  speakerList.value = [
    normalizeSpeaker(mergedSpeaker),
    ...speakerList.value
      .filter((item) => !isSameSpeakerId(item?.id, speaker.id))
      .map((item) => normalizeSpeaker(item)),
  ];
};
const shouldHoldDraftSpeakerSelection = () => Number(remakeSpeakerId.value) > 0
  && !speakerSelectionTouched.value
  && !remakeSpeakerResolved.value;
const restoreDraftSpeakerFromList = () => {
  if (!shouldHoldDraftSpeakerSelection()) return;
  const target = findSpeakerById(speakerList.value, remakeSpeakerId.value);
  if (!target) return;

  selectSpeakerInfo.value = target;
  remakeSpeakerRestorePending.value = false;
  remakeSpeakerResolved.value = true;
};
const loadRemakeSpeakerDetail = async (voiceId) => {
  const speakerId = Number(voiceId);
  if (!Number.isFinite(speakerId) || speakerId <= 0) return;

  remakeSpeakerDetailLoading.value = true;
  remakeSpeakerRestorePending.value = true;
  try {
    const response = await axios({
      method: 'post',
      url: '/v2/user/voice/show',
      data: JSON.stringify({
        voice_id: speakerId,
      }),
    });

    if (response?.data?.code !== 1 || !response?.data?.data?.id) {
      throw new Error(response?.data?.msg || '草稿人声不可用');
    }

    const speaker = normalizeSpeaker(response.data.data);
    const isStillSelectedSpeaker = isSameSpeakerId(selectSpeakerInfo.value?.id, speaker.id);
    if (!speakerSelectionTouched.value || isStillSelectedSpeaker) {
      upsertSpeakerToList(speaker);
    }
    syncFavoriteSpeakerIds();
    remakeSpeakerRestorePending.value = false;

    if (!speakerSelectionTouched.value) {
      selectSpeakerInfo.value = speaker;
      remakeSpeakerResolved.value = true;
    } else if (isSameSpeakerId(selectSpeakerInfo.value?.id, speaker.id)) {
      selectSpeakerInfo.value = speaker;
    }
  } catch (error) {
    remakeSpeakerRestorePending.value = false;
    if (isAuthExpiredError(error)) return;

    const target = findSpeakerById(speakerList.value, speakerId);
    if (!speakerSelectionTouched.value && target) {
      selectSpeakerInfo.value = target;
      remakeSpeakerResolved.value = true;
      return;
    }

    if (!speakerSelectionTouched.value) {
      message.warning(getApiErrorMessage(error, '草稿人声不可用，请重新选择人声'));
    }
  } finally {
    remakeSpeakerDetailLoading.value = false;
  }
};

// 请求人声列表
const getSperkerList = async (type) => {
  console.log(type);
  console.log(speakerType.value);

  console.log(loading.value);
  console.log(hasMore.value);
  if (loading.value){
    // 如果正在加载，则不进行新的请求
    return;
  }

  if (type === FAVORITE_SPEAKER_TAB) {
    speakerType.value = type;
    loading.value = false;
    hasMore.value = false;
    page.value = 1;

    try {
      const response = await axios({
        method: 'post',
        url: '/v2/user/voice/favorites/index',
        data: JSON.stringify({
          page: 1,
          per_page: 100,
        })
      });

      const mergedList = Array.isArray(response?.data?.data) ? response.data.data : [];
      speakerList.value = mergedList.map((item) => normalizeSpeaker({
        ...item,
        is_favorite: true,
      }));
      syncFavoriteSpeakerIds();
      if (hasSelectedSpeaker()) {
        upsertSpeakerToList(selectSpeakerInfo.value);
      }
      restoreDraftSpeakerFromList();
      if (!shouldHoldDraftSpeakerSelection()) {
        syncSelectedSpeakerFromList();
      }
    } catch (error) {
      if (isAuthExpiredError(error)) {
        return;
      }
      message.error(getApiErrorMessage(error, '获取收藏人声失败'));
    }
    return;
  }

  // 如果人声类型与当前选择的人声类型不同，则清空人声列表
  // 并重置页码和加载状态
  if(speakerType.value != type){
    speakerList.value = [];
    hasMore.value = true;
    page.value = 1; // 重置页码
    if (observer){
      observer.disconnect();
      observer.observe(loaderRef.value);
    }
  }

  // 如果没有更多数据且当前人声类型与请求类型相同，则不进行新的请求
  if (!hasMore.value && speakerType.value == type) return;

  loading.value = true;
  speakerType.value = type;
  var data = JSON.stringify({
    "page": page.value,
    "per_page": 15,
    "type": type,
  });

  var config = {
    method: 'post',
    url: '/v2/user/voice/index',
    data : data
  };

  try {
    const response = await axios(config);

    if (response.data.data.length === 0) {
      hasMore.value = false;
      if (hasSelectedSpeaker()) {
        upsertSpeakerToList(selectSpeakerInfo.value);
      }
    } else {
      const incomingList = Array.isArray(response?.data?.data) ? response.data.data : [];
      const normalizedIncomingList = incomingList.map((item) => normalizeSpeaker(item));
      if (hasSelectedSpeaker()) {
        upsertSpeakerToList(selectSpeakerInfo.value);
      }
      speakerList.value = mergeSpeakerList(speakerList.value, normalizedIncomingList);
      syncFavoriteSpeakerIds();
      restoreDraftSpeakerFromList();
      if (!shouldHoldDraftSpeakerSelection()) {
        syncSelectedSpeakerFromList();
      }
    }
  } catch (error) {
    if (isAuthExpiredError(error)) {
      hasMore.value = false;
      return;
    }
    message.error(getApiErrorMessage(error, '获取人声列表失败'));
    return false;
  } finally {
    page.value += 1;
    loading.value = false;
  }

}

// 选择人声
const selectSpeaker = (speaker) => {
  speakerSelectionTouched.value = true;
  remakeSpeakerRestorePending.value = false;
  selectSpeakerInfo.value = speaker;
  // console.log(speaker);
  // auditionPlay(speaker.src);
}
// 背景音乐音量变化
const bgvolumeChange = (value) => {
  bgvolume.value = value;
  if(auditionHowl.value && auditionHowl.value.playing()){
    auditionHowl.value.volume(value * 0.01);
  }
}
const stopAuditionHowl = ({ resetState = true } = {}) => {
  auditionPlaybackSessionId.value += 1;
  const currentHowl = auditionHowl.value;
  if(currentHowl){
    currentHowl.stop();
    currentHowl.unload();
    auditionHowl.value = null;
  }
  if(resetState){
    auditionLoading.value = false;
    auditionPlayId.value = null;
    progress.value = 0;
  }
}
// 试听 speaker bgmusic
// speed_value.value = settingInfo.value.speedPCT != undefined ? settingInfo.value.speedPCT : 50; //语速 1 0.5~2
// gain_value.value = settingInfo.value.gainPCT != undefined ? settingInfo.value.gainPCT : 50; //音量增益 0 -20~20
const auditionPlay = (event, id, src) => {
  event && event.stopPropagation && event.stopPropagation();

  if(auditionHowl.value && auditionPlayId.value == id){
    if (auditionHowl.value.playing()) {
      auditionHowl.value.pause();
      auditionLoading.value = false;
    } else {
      progress.value = 0
      auditionHowl.value.play();
    }
    // auditionPlayId.value = 0;
  }else{

    if(isTryPreview.value){
      audition();
    }

    stopAuditionHowl({ resetState: false });
    const sessionId = auditionPlaybackSessionId.value;
    progress.value = 0
    auditionLoading.value = true;
    auditionPlayId.value = id;

    const newAuditionHowl = new Howl({
      src: [src],
      // 可选配置项
      // autoplay: true, // 自动播放
      loop: false, // 循环播放
      // rate: speakerList.value[index].speed == undefined? 1 : speakerList.value[index].speed, // 播放速率 0.5 到 4.0
      // volume: speakerList.value[index].gainPCT == undefined? 1 : speakerList.value[index].gainPCT / 100, // 音量
      volume: bgvolume.value * 0.01,
      onplay: () => {
        if(sessionId !== auditionPlaybackSessionId.value || auditionPlayId.value !== id) return;
        auditionLoading.value = false;
        requestAnimationFrame(updateProgress);
      },
      onend: () => {
        if(sessionId !== auditionPlaybackSessionId.value || auditionPlayId.value !== id) return;
        auditionLoading.value = false;
        auditionPlayId.value = null;
        auditionHowl.value = null;
        progress.value = 0;
        newAuditionHowl.unload();
      },
      onstop: () => {
        if(sessionId !== auditionPlaybackSessionId.value || auditionPlayId.value !== id) return;
        auditionLoading.value = false;
        auditionPlayId.value = null;
        auditionHowl.value = null;
        progress.value = 0;
      },
      onloaderror: () => {
        if(sessionId !== auditionPlaybackSessionId.value || auditionPlayId.value !== id) return;
        auditionLoading.value = false;
        auditionPlayId.value = null;
        auditionHowl.value = null;
        progress.value = 0;
        newAuditionHowl.unload();
        message.error('试听资源加载失败');
      },
      onplayerror: () => {
        if(sessionId !== auditionPlaybackSessionId.value || auditionPlayId.value !== id) return;
        auditionLoading.value = false;
        auditionPlayId.value = null;
        auditionHowl.value = null;
        progress.value = 0;
        newAuditionHowl.unload();
        message.error('试听资源播放失败');
      },
    });
    auditionHowl.value = newAuditionHowl;
    // 直接播放
    auditionHowl.value.play();

  }


}

// 进度更新函数
const updateProgress = () => {
    if (auditionHowl.value && auditionHowl.value.playing()) {
        progress.value = (auditionHowl.value.seek() / auditionHowl.value.duration()) * 100|| 0;
        requestAnimationFrame(updateProgress);
    }
}
// 进度更新函数
const updateProgressSpeaker = () => {
    if (sound.value && sound.value.playing()) {
        progress.value = (sound.value.seek() / sound.value.duration()) * 100|| 0;
        requestAnimationFrame(updateProgressSpeaker);
    }
}
// 删除自定义人声
const deleteCustomSpeaker = (index, speakerId) => {
  var data = JSON.stringify({
    "voice_id": speakerId
  });

  var config = {
    method: 'post',
    url: '/v2/user/voice/delete',
    data : data
  };

  axios(config)
  .then(function (response) {
    if(response.data.code == 1){
      // message.success('删除成功');
      message.success(response.data.msg);
      speakerList.value.splice(index, 1);
    }else{
      message.error(getApiResponseErrorMessage(response, '删除人声失败'));
    }
  })
  .catch(function (error) {
    if (isAuthExpiredError(error)) {
      return false;
    }
    message.error(getApiErrorMessage(error, '删除人声失败'));
  });
}
// 开启自定义人声上传
const customSpeaker = () => {
  customSpeakerOpen.value = true;
}
// 导入文本文件
const importContentFile = (mode = 'text', event) => {
  if (event?.preventDefault) {
    event.preventDefault();
  }

  contentImportType.value = mode;

  if(isEditorEmpty.value){
    // 设置焦点
    editorRef.value.focus();
    saveSelectionRange();
  }else{
    // 保存当前选区
    restoreSelection();
    if (!isSelectionInEditableDiv()) {
      message.warning('请确保光标或选中内容在可编辑区域内');
      return false;
    }

  }
  contentFileOpen.value = true;
}
const openBackmusicLibrary = () => {
  const shouldStopAudition = !backmusicFileOpen.value;
  backmusicFileOpen.value = true;
  if (shouldStopAudition) {
    stopAuditionHowl();
  }
  backmusicStore(undefined, { source: 'initial' });
}

// 请求背景音乐列表
const backmusicStore = (targetType, options = {}) => {
  backmusicFileOpen.value = true;

  const requestOptions = typeof options === 'boolean'
    ? { source: options ? 'scroll' : 'initial' }
    : options;
  const requestSource = requestOptions?.source || 'initial';
  const shouldLoadMore = requestSource === 'scroll';
  const shouldReset = requestOptions?.reset === true;

  const currentType = Number.isInteger(targetType)
    ? targetType
    : (Number.parseInt(musicLibraryActiveKey.value, 10) || 0);

  if (!requireLoginForCustomMusic(currentType)) {
    return;
  }

  // 首次打开弹窗或切换 Tab 时，等待 DOM 渲染后再绑定观察器（否则 ref 可能还是 null）
  nextTick(() => {
    recreateMusicObserver();
  });

  if(musicLoadingMap.value[currentType]){
    return;
  }

  if (shouldReset) {
    resetMusicPaginationForType(currentType);
  }

  // 仅在显式切换当前展示 Tab 时，同步镜像状态（不重置）
  if(currentType === (Number.parseInt(musicLibraryActiveKey.value, 10) || 0)){
    syncActiveMusicState(currentType);
    nextTick(() => {
      recreateMusicObserver();
    });
  }

  if (musicLoadedMap.value[currentType] && !shouldLoadMore) return;
  if (!musicHasMoreMap.value[currentType]) return;

  musicLoadingMap.value[currentType] = true;
  if(currentType === (Number.parseInt(musicLibraryActiveKey.value, 10) || 0)){
    musicLoading.value = true;
  }

  var data = JSON.stringify({
    "page": musicPageMap.value[currentType] || 1,
    "type": currentType,
  });

  var config = {
    method: 'post',
    url: '/v2/user/background_music/index',
    data : data
  };

  axios(config)
  .then(function (response) {
    const list = response?.data?.data || [];
    musicLoadedMap.value[currentType] = true;
    if (list.length === 0) {
      musicHasMoreMap.value[currentType] = false;
    } else {
      const merged = mergeMusicList(musicLibraryMap.value[currentType] || [], list);
      musicLibraryMap.value[currentType] = merged;
      if (currentType === (Number.parseInt(musicLibraryActiveKey.value, 10) || 0)) {
        musicLibrary.value = merged;
      }
      musicPageMap.value[currentType] = (musicPageMap.value[currentType] || 1) + 1;
    }

    // 同步当前Tab镜像状态
    if (currentType === (Number.parseInt(musicLibraryActiveKey.value, 10) || 0)) {
      musicPage.value = musicPageMap.value[currentType] || 1;
      musicHasMore.value = musicHasMoreMap.value[currentType] ?? true;
    }
  })
  .catch(function (error) {
    if (isAuthExpiredError(error)) {
      stopMusicPaginationForType(currentType);
      return;
    }
    message.error(getApiErrorMessage(error, '获取背景音乐失败'));
  }).finally(() => {
    musicLoadingMap.value[currentType] = false;
    musicScrollTouchedMap.value[currentType] = false;
    // 仅当当前仍停留在该 tab 时，更新展示态
    if ((Number.parseInt(musicLibraryActiveKey.value, 10) || 0) === currentType) {
      musicLoading.value = false;
      musicHasMore.value = musicHasMoreMap.value[currentType] ?? true;
      musicPage.value = musicPageMap.value[currentType] || 1;
      nextTick(() => {
        recreateMusicObserver();
        autoFillMusicListIfNeeded(currentType);
      });
    }
  });

}

// 上传背景音乐
const backmusicUpload = () => {
  if (!requireLoginForCustomMusic(CUSTOM_MUSIC_TYPE)) {
    return;
  }

  if(fileList.value.length == 0){
    message.warning('请先选择文件。');
    return;
  }
  if(fileList.value.length > 1){
    message.warning('只能上传一个文件。');
    return;
  }
  if(fileList.value[0].size > 20971520){
    message.warning('文件大小不能超过20MB。');
    return;
  }

  const formData = new FormData();
  formData.append('upload_file',fileList.value[0]);
  uploading.value = true;
  var config = {
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    url: '/v2/user/background_music/store',
    data : formData
  };

  axios(config)
  .then(function (response) {
    fileList.value = [];
    uploading.value = false;
    message.success(response.data.msg);

    const uploadedMusic = normalizeUploadedMusic(response.data);
    if (prependCustomMusic(uploadedMusic)) {
      nextTick(() => {
        recreateMusicObserver();
        autoFillMusicListIfNeeded(CUSTOM_MUSIC_TYPE);
      });
      return;
    }

    backmusicStore(CUSTOM_MUSIC_TYPE, { reset: true });

  })
  .catch(function (error) {
    fileList.value = [];
    uploading.value = false;
    if (isAuthExpiredError(error)) {
      stopMusicPaginationForType(CUSTOM_MUSIC_TYPE);
      return;
    }
    message.error(getApiErrorMessage(error, '上传背景音乐失败'));
  });
}
const removeBackmusic = (event) => {
  event.stopPropagation();
  confirmBackmusicInfo.value = {};
}
const confirmBackmusicFile = () => {
  // auditionHowl.value.pause();
  auditionPlayId.value = 0;
  backmusicFileOpen.value = false;
  confirmBackmusicInfo.value = selectBackmusicInfo.value;
  if(bgsound.value){
    bgsound.value.stop();
    bgsound.value = null;
  }
  if(auditionHowl.value && auditionHowl.value.playing()){
    auditionHowl.value.pause();
  }

}
// 选择背景音乐
const selectBackmusicFile = (event, music) => {
  event.stopPropagation();
  selectBackmusicInfo.value = music;
}
// 删除背景音乐
const deleteCustomBackmusic = (index, musicId) => {
  if (!requireLoginForCustomMusic(CUSTOM_MUSIC_TYPE)) {
    return;
  }

  var data = JSON.stringify({
    "music_id": musicId
  });

  var config = {
    method: 'post',
    url: '/v2/user/background_music/delete',
    data : data
  };

  axios(config)
  .then(function (response) {
    if(response.data.code == 1){
      // message.success('删除成功');
      message.success(response.data.msg);
      musicLibrary.value.splice(index, 1);
    }else{
      message.error(getApiResponseErrorMessage(response, '删除背景音乐失败'));
    }
  })
  .catch(function (error) {
    if (isAuthExpiredError(error)) {
      stopMusicPaginationForType(CUSTOM_MUSIC_TYPE);
      return;
    }
    message.error(getApiErrorMessage(error, '删除背景音乐失败'));
  });
}
// 删除已选择未上传的文件
const handleRemove = file => {
  const index = fileList.value.indexOf(file);
  const newFileList = fileList.value.slice();
  newFileList.splice(index, 1);
  fileList.value = newFileList;
};
// 上传之前的处理
const beforeUpload = file => {
  fileList.value[0] =  file;
  return false;
};
// 关闭或取消modal
const handleCancel = () => {
  customSpeakerOpen.value = false;

  contentFileOpen.value = false;

  fileSettingOpen.value = false;

  if(auditionHowl.value && auditionHowl.value.playing()){
    auditionHowl.value.pause();
  }
  if(backmusicFileOpen.value){
    backmusicFileOpen.value = false;
    confirmBackmusicInfo.value = {};
    selectBackmusicInfo.value = {'id':0};
  }
  fileList.value = [];
  noiseReduction.value = null;

};
// 上传人声
const uploadCustomSpeaker = () => {
  const formData = new FormData();
  formData.append('upload_file',fileList.value[0]);
  formData.append('audio_normalizer',speakerOptimize.value);
  formData.append('noise_reduction', noiseReduction.value === true);
  uploading.value = true;
  if(fileList.value.length == 0){
    message.warning('请先选择文件。');
    return;
  }
  if(fileList.value.length > 1){
    message.warning('只能上传一个文件。');
    return;
  }
  // console.log(fileList.value[0]);
  if(fileList.value[0].size > 3145728){
    message.warning('文件大小不能超过3MB。');
    return;
  }
  // var data = JSON.stringify({
  //   "upload_file": fileList.value[0],
  //   "audio_normalizer": speakerOptimize.value,
  // });

  var config = {
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    url: '/v2/user/voice/store',
    data : formData
  };

  axios(config)
  .then(function (response) {
    fileList.value = [];
    uploading.value = false;
    customSpeakerOpen.value = false;
    message.success(response.data.msg);
    speakerList.value = []; // 清空人声列表
    page.value = 1; // 重置页码
    hasMore.value = true; // 重置加载状态
    getSperkerList(1); // 重新获取人声列表
    // message.success('上传成功');

  })
  .catch(function (error) {
    uploading.value = false;
    if (isAuthExpiredError(error)) {
      return false;
    }
    message.error(getApiErrorMessage(error, '上传人声失败'));
  });
}
// 导入文本文件
const uploadContentFile = (event) => {
  event?.preventDefault?.();
  restoreSelection();

  const currentImportMode = contentImportMode.value;

  if(fileList.value.length == 0){
    message.warning(currentImportMode.emptyMessage);
    return;
  }
  if(fileList.value.length > 1){
    message.warning(currentImportMode.tooManyMessage);
    return;
  }
  if(fileList.value[0].size > currentImportMode.maxSize){
    message.warning(currentImportMode.tooLargeMessage);
    return;
  }

  const formData = new FormData();
  formData.append(currentImportMode.fieldName, fileList.value[0]);
  currentImportMode.extraFields.forEach((field) => {
    formData.append(field.key, field.value);
  });

  uploading.value = true;
  var config = {
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    url: currentImportMode.endpoint,
    data : formData
  };

  axios(config)
  .then(function (response) {
    if(response.data.code == 1){
      if (isSelectionInEditableDiv()) {
        const parsedText = currentImportMode.responseText(response);
        if (!parsedText) {
          uploading.value = false;
          message.warning('未提取到可用文本内容');
          return;
        }

        fileList.value = [];
        uploading.value = false;
        contentFileOpen.value = false;
        doPaste(parsedText);
        message.success(response.data.msg);
      } else {
        uploading.value = false;
        message.warning('请确保光标或选中内容在可编辑区域内');
      }
    }else{
      uploading.value = false;
      message.error(getApiResponseErrorMessage(response, '导入文件失败'));
    }
  })
  .catch(function (error) {
    uploading.value = false;
    if (isAuthExpiredError(error)) {
      return false;
    }
    message.error(getApiErrorMessage(error, '导入文件失败'));
  });
}
// 设置人声参数
const settingSpeaker = (event, index) => {
  event.stopPropagation();
  settingIndex.value = index;
  settingInfo.value = speakerList.value[index];
  originalCustomSpeakerName.value = settingInfo.value?.file_name || '';
  isEditCustomSpeakerName.value = false;
  speed_value.value = settingInfo.value.speedPCT != undefined ? settingInfo.value.speedPCT : 50; //语速 1 0.5~2
  gain_value.value = settingInfo.value.gainPCT != undefined ? settingInfo.value.gainPCT : 50; //音量增益 0 -20~20
}

const activeChangeCustomSpeakerName = () => {
  if (!settingInfo.value) {
    return;
  }

  const name = (settingInfo.value.file_name || '').trim();
  if (!name) {
    settingInfo.value.file_name = '未命名人声';
  }
}

const editCustomSpeakerNameFocus = async () => {
  if (speakerType.value !== 1 || customSpeakerNameSaving.value) {
    return;
  }

  isEditCustomSpeakerName.value = true;
  await nextTick();
  customSpeakerNameInputRef.value?.focus?.();
}

const handleCustomSpeakerNameBlur = async () => {
  if (!isEditCustomSpeakerName.value) {
    return;
  }

  await updateCustomSpeakerName();
  isEditCustomSpeakerName.value = false;
}

const updateCustomSpeakerName = async () => {
  if (speakerType.value !== 1 || !settingInfo.value?.id) {
    return false;
  }

  const name = (settingInfo.value.file_name || '').trim();
  if (!name) {
    message.warning('请输入人声名称');
    return false;
  }

  settingInfo.value.file_name = name;
  if (name === (originalCustomSpeakerName.value || '').trim()) {
    return true;
  }

  customSpeakerNameSaving.value = true;
  try {
    const response = await axios({
      method: 'post',
      url: '/v2/user/voice/update',
      data: JSON.stringify({
        voice_id: settingInfo.value.id,
        name,
      })
    });

    if (response?.data?.code !== 1) {
      message.error(response?.data?.msg || '修改名称失败');
      return false;
    }

    if (speakerList.value[settingIndex.value]) {
      speakerList.value[settingIndex.value].file_name = name;
    }
    originalCustomSpeakerName.value = name;
    if (selectSpeakerInfo.value?.id === settingInfo.value.id) {
      selectSpeakerInfo.value.file_name = name;
    }

    message.success(response?.data?.msg || '更新成功');
    autoSave();
    return true;
  } catch (error) {
    if (isAuthExpiredError(error)) {
      return false;
    }
    message.error(getApiErrorMessage(error, '修改人声名称失败'));
    return false;
  } finally {
    customSpeakerNameSaving.value = false;
  }
}

// 映射人声参数
const mapSpeakerSetting = (value, type, index) => {
  value = Number(value);
  // console.log(value, type, index);
  // const speed_value = ref(50); //语速 1 0.5~2  0.8~1.2
  // const gain_value = ref(50); //音量增益 0 -20~20
  if(type == 'speed'){
    speakerList.value[index].speedPCT = value;
    //语速默认1 服务器接受值0.5~2映射到100
    if(value >= 50){
      value = 1+((value-50) / 50);
    }else{
      value = 1-((50-value) / 100);
    }
    //限制区间 0.8~1.2 映射到100
    // value = (value * 0.015 + 0.5).toFixed(2);
    speakerList.value[index].speed = Number(value);
  }else if(type == 'gain'){
    speakerList.value[index].gainPCT = value;
    value = 0.4 * value - 20
    speakerList.value[index].gain = Number(value);
  }
}
const downloadFile = async (blobData) => {
  console.log(blobData);
  try {
    const response = await axios.get(fileUrl, {
      responseType: 'blob', // 设置响应类型为 'blob'
    });
    // 创建 Blob 对象
    // const blob = new Blob([response.data], { type: response.data.type }); //audio/x-wav
    const url = window.URL.createObjectURL(blobData);

    // 创建链接并触发下载
    const link = document.createElement('a');
    link.href = url;
    link.download = filename.value+'.'+ filetype.value; // 设置下载的文件名
    link.click();

    // 释放 URL 对象
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('下载文件出错：', error);
  }
}
// 下载合成文件
const downloadFileForUrl = async  (fileUrl) => {
  try {
    const response = await axios.get(fileUrl, {
      responseType: 'blob', // 设置响应类型为 'blob'
    });
    // 创建 Blob 对象
    const blob = new Blob([response.data], { type: response.data.type }); //audio/x-wav
    const url = window.URL.createObjectURL(blob);

    // 创建链接并触发下载
    const link = document.createElement('a');
    link.href = url;
    link.download = filename.value+'.'+ filetype.value; // 设置下载的文件名
    link.click();

    // 释放 URL 对象
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('下载文件出错：', error);
  }
}

const editNameFoucs = async () => {
    isEditName.value = true;
    await nextTick()
    inputRef.value.focus()
}
const finishEditName = () => {
  isEditName.value = false;
  activeChangeFilename();
}
const selectAllText = (event) => {
  event.target.select()
}
const saveDraft = () => {
  // 保存草稿
  const text = editorRef.value.innerText;
  const html = editorRef.value.innerHTML;
  if(isEditorEmpty.value){
    message.warning('内容不能为空，请输入内容后再保存。');
    return;
  }
  if (!hasSelectedSpeaker()) {
    message.warning('请选择人声');
    return;
  }

  var data = JSON.stringify({
    "title": filename.value,
    "tts_text": text,
    "tts_html": html,
    "voice_id": selectSpeakerInfo.value.id,
    "music_id": confirmBackmusicInfo.value ? confirmBackmusicInfo.value.id : 0,
    "bg_volume": bgvolume.value*0.01,
    "text_draft_id": draft_id.value || 0,
  });

  var config = {
    method: 'post',
    url: '/v2/user/draft/store',
    data : data
  };

  axios(config)
  .then(function (response) {
    if(response.data.code == 1){
      message.success(response.data.msg);
    }else{
      message.error(getApiResponseErrorMessage(response, '保存草稿失败'));
    }
    autoSave();
  })
  .catch(function (error) {
    if (isAuthExpiredError(error)) {
      return false;
    }
    message.error(getApiErrorMessage(error, '保存草稿失败'));
  });
}

const userCenter = () => {
  if (isLoggedIn()) {
    router.push('/works');
    return;
  }
  loginModalOpen.value = true;
}

const isLoggedIn = () => {
  return !!loginToken.value;
}

const onPhoneInput = () => {
  loginForm.value.phone = (loginForm.value.phone || '').replace(/\D/g, '').slice(0, 11);
}

const startSmsCountdown = () => {
  smsCountdown.value = 60;
  if (smsTimer) clearInterval(smsTimer);
  smsTimer = setInterval(() => {
    if (smsCountdown.value <= 1) {
      clearInterval(smsTimer);
      smsTimer = null;
      smsCountdown.value = 0;
      return;
    }
    smsCountdown.value -= 1;
  }, 1000);
}

const sendSmsCode = async () => {
  const phone = (loginForm.value.phone || '').trim();
  if (!/^1\d{10}$/.test(phone)) {
    message.warning('请输入正确的11位手机号');
    return;
  }
  smsSending.value = true;
  try {
    const data = {
      phone,
      device_id: localStorage.getItem('device_id') || '',
    };
    const response = await axios({
      method: 'post',
      url: '/v2/user/sms/send',
      data,
    });
    if (response.data?.code === 1) {
      message.success(response.data?.msg || '验证码发送成功');
      startSmsCountdown();
    } else {
      message.error(response.data?.msg || '验证码发送失败');
    }
  } catch (error) {
    message.error(getApiErrorMessage(error, '验证码发送失败'));
  } finally {
    smsSending.value = false;
  }
}

const handleLogin = async () => {
  const phone = (loginForm.value.phone || '').trim();
  const code = (loginForm.value.code || '').trim();

  if (!/^1\d{10}$/.test(phone)) {
    message.warning('请输入正确的11位手机号');
    return;
  }
  if (!/^\d{4,6}$/.test(code)) {
    message.warning('请输入正确的验证码');
    return;
  }

  loginLoading.value = true;
  try {
    const response = await axios({
      method: 'post',
      url: '/v2/user/login',
      data: { phone, code },
    });

    if (response.data?.code === 1 && response.data?.data?.access_token) {
      const token = response.data.data.access_token;
      const tokenType = response.data.data.token_type || 'bearer';
      setAuthToken(token, tokenType);
      loginToken.value = token;
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      resetMusicPaginationForType(CUSTOM_MUSIC_TYPE);

      message.success(response.data?.msg || '登录成功');
      loginModalOpen.value = false;
      if (backmusicFileOpen.value && isCustomMusicType(Number.parseInt(musicLibraryActiveKey.value, 10) || 0)) {
        backmusicStore(CUSTOM_MUSIC_TYPE);
      }
      return;
    }
    message.error(response.data?.msg || '登录失败');
  } catch (error) {
    message.error(getApiErrorMessage(error, '登录失败'));
  } finally {
    loginLoading.value = false;
  }
}
const filenameInit = () => {
  if(filename.value == ''){
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;  // 月份从0开始，所以要加1
    const day = now.getDate();
    filename.value = '未命名_'+year+''+month+''+day;
  }

}
//[{
// "id":35,
// "content":"生活在上海的南非人坦迪丝瓦·洛西，有一个很有意思的说法：“带着心跳的中国式现代化”。什么叫“带着心跳”？磁悬浮列车疾驰，像是“踏入了科幻小说”；豫园里的园林、池塘、石桥，尽显古朴……洛西在中国看到了现代与传统的和谐交融，“中国的现代化进程并未抛弃它的过去”“而是要创建一个忠实于自己的未来”。",
// "text_parameter":"{
//                      \"voice_id\": 103,
//                       \"music_id\": 0,
//                        \"bg_volume\": 0
//                    }",
// }]

const ttsRemake = () => {
  let ttsRemake = JSON.parse(localStorage.getItem('ttsRemake'));
  if(ttsRemake){
    // 如果存在本地存储的tts信息，则使用它
    console.log('找到本地存储的tts信息');
    let ttsInfo = ttsRemake;
    // doPaste(ttsInfo.content);
    editorRef.value.innerHTML = ttsInfo.content_html;
    checkEmptyState();

    if(ttsInfo.music_id != 0){
      confirmBackmusicInfo.value.id = ttsInfo.music_id;
      confirmBackmusicInfo.value.title = ttsInfo.music_title;
      confirmBackmusicInfo.value.path = ttsInfo.music_path;
    }
    if(ttsInfo.type == 'draft'){
      draft_id.value = ttsInfo.id || 0;
    }
    bgvolume.value = ttsInfo.bg_volume * 100 || 30;
    const speakerId = Number(ttsInfo.voice_id);
    remakeSpeakerId.value = Number.isFinite(speakerId) && speakerId > 0 ? speakerId : 0;
    remakeSpeakerDetailLoading.value = false;
    remakeSpeakerRestorePending.value = false;
    remakeSpeakerResolved.value = false;
    speakerSelectionTouched.value = false;
    if (remakeSpeakerId.value > 0) {
      loadRemakeSpeakerDetail(remakeSpeakerId.value);
    }
    filename.value = ttsInfo.title;
    largeModel.value = Number.isFinite(Number(ttsInfo.large_model)) ? Number(ttsInfo.large_model) : largeModel.value;
    if (Array.isArray(ttsInfo.favorite_speaker_ids)) {
      favoriteSpeakerIds.value = ttsInfo.favorite_speaker_ids.map((id) => Number(id)).filter((id) => Number.isFinite(id));
    }
    isActiveChange.value = true;

  }else{
    // 如果不存在，则初始化一个空的段落
    console.log('没有找到本地存储的tts信息');
    return true;
  }
  // 初始化空段落
  selectSpeakerInfo.value = {
    id: 0,
    name: '请选择人声',
    src: '',
    speedPCT: 50,
    gainPCT: 50,
    vcnType: 4, // 人声类型
    lanType: 1, // 语言类型
  }
}
// [{
// "id":44,
// "title":"心跳zhangjiakou",
// "content":"这个“心跳”，是千年文脉的跃动，亘古亘今、生生不息。从“考古热”“文博热”“国潮风”，到“魔童降世”、“黑悟空”出世、“唐宫夜宴”舞动网络，越来越多“古老的”正在成为“新生的”，融入现代生活；从苏州致力于“产城人文”深度融合，到杭州在“人间天堂”“网红之都”与“未来之城”中书写新传奇，传统文化与现代经济相互滋养、交织，正在绘就高质量发展的时代画卷。从中可以更深刻感悟“从中华大地长出来的”中国式现代化，是“文明更新的结果”。从未中断的中华文明，从历史深处走来，正走向更远的未来。这个“心跳”，是现实发展的脉动。心脏自主有规律地跳动，身体才能保持旺盛的生命力，发展同样要保持强大的内驱力。过去的洋火、洋皂、洋铁等靠买进来，如今中国制造业拥有完备齐全的产业链，不仅自足还供应世界。《纽约时报》曾指出，很难想象，一个没有中国产品的美国家庭会是什么模样。何以不再“洋”字当头？唯有自立自强。实践证明，现代化之路的关键，是走自己的路，“中国发展最终还是要靠自己”。",
// "content_html":"<p class=\"tts-content-paragraph\">这个“心跳”，是千年文脉的跃动，亘古亘今、生生不息。从“考古热”“文博热”“国潮风”，到“魔童降世”、“黑悟空”出世、“唐宫夜宴”舞动网络，越来越多“古老的”正在成为“新生的”，融入现代生活；从苏州致力于“产城人文”深度融合，到杭州在“人间天堂”“网红之都”与“未来之城”中书写新传奇，传统文化与现代经济相互滋养、交织，正在绘就高质量发展的时代画卷。从中可以更深刻感悟“从中华大地长出来的”中国式现代化，是“文明更新的结果”。从未中断的中华文明，从历史深处走来，正走向更远的未来。</p><p class=\"tts-content-paragraph\">这个“心跳”，是现实发展的脉动。心脏自主有规律地跳动，身体才能保持旺盛的生命力，发展同样要保持强大的内驱力。过去的洋火、洋皂、洋铁等靠买进来，如今中国制造业拥有完备齐全的产业链，不仅自足还供应世界。《纽约时报》曾指出，很难想象，一个没有中国产品的美国家庭会是什么模样。何以不再“洋”字当头？唯有自立自强。实践证明，现代化之路的关键，是走自己的路，“中国发展最终还是要靠自己”。</p>",
// "voice_id":109,
// "music_title":"tip.mp3",
// "music_path":"bg_music/2025/05/bg250508171620_01.mp3",
// "music_id":34,
// "bg_volume":0.3
// }]
const autoSave = () => {
  // 保存草稿
  if (!hasSelectedSpeaker()) return false;
  const text = editorRef.value.innerText;
  const html = editorRef.value.innerHTML;
  let ttsInfo = {}
  if(selectSpeakerInfo.value){
    ttsInfo = {
      title: filename.value,
      content: text,
      content_html: html,
      voice_id: selectSpeakerInfo.value.id,
      bg_volume: bgvolume.value * 0.01,
      large_model: Number(largeModel.value),
      favorite_speaker_ids: favoriteSpeakerIds.value,
    };
  }else{
    return false;
  }
  if(confirmBackmusicInfo.value.id){
    ttsInfo.music_id = confirmBackmusicInfo.value.id;
    ttsInfo.music_title = confirmBackmusicInfo.value.title;
    ttsInfo.music_path = confirmBackmusicInfo.value.path;
  }
  localStorage.setItem('ttsRemake', JSON.stringify(ttsInfo))
}
// watch(filename, val => {

//   if(val != ''){
//     console.log('filename changed:', val);
//     autoSave();
//   }
// });
// watch(selectSpeakerInfo, val => {

//   if(val != ''){
//     console.log('selectSpeakerInfo changed:', val);
//     autoSave();
//   }
// });
watch(largeModel, () => {
  autoSave();
});

watch(backmusicFileOpen, (open) => {
  if (!open) {
    stopAuditionHowl();
  }
});

watch(musicLibraryActiveKey, async () => {
  const currentType = Number.parseInt(musicLibraryActiveKey.value, 10) || 0;
  stopAuditionHowl();
  musicScrollTouchedMap.value[currentType] = false;
  syncActiveMusicState(currentType);

  await nextTick();
  recreateMusicObserver();

  // 只在当前 Tab 还没加载过数据时，主动拉第一页
  if (!musicLoadedMap.value[currentType] && !musicLoadingMap.value[currentType]) {
    backmusicStore(currentType);
  }
});
// watch(editorRef, val => {

//   if(!isEditorEmpty){
//     console.log('editorRef changed:', val);
//     autoSave();
//   }
// });
// 初始化空段落
onMounted(async () => {
  window.addEventListener(AUTH_EXPIRED_EVENT, handleAuthExpiredEvent);
  // downloadFileForUrl('http://192.168.0.203:50000/v2/user/production/download/41/0');
  ttsRemake();
  filenameInit();
  await loadLargeModelOptions();
  getSperkerList(speakerType.value);

  // 创建观察器
  observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting && !loading.value) {
      getSperkerList(speakerType.value);
    }
  }, {
    root: null, // 相对于视口
    threshold: 0.1,
    rootMargin: '0px 0px 100px 0px' // 提前100px加载
  });

  if (loaderRef.value) {
    observer.observe(loaderRef.value);
  }

  const initMusicType = Number.parseInt(musicLibraryActiveKey.value, 10) || 0;
  musicType.value = initMusicType;
  await nextTick();
  recreateMusicObserver();

});
onBeforeUnmount(() => {
  window.removeEventListener(AUTH_EXPIRED_EVENT, handleAuthExpiredEvent);
  if(auditionHowl.value){
    auditionHowl.value.stop();
  }
  if(sound.value){
    sound.value.stop();
  }
  if(bgsound.value){
    bgsound.value.stop();
  }
  if (observer) observer.disconnect();
  if (musicObserver) musicObserver.disconnect();
  if (smsTimer) {
    clearInterval(smsTimer);
    smsTimer = null;
  }
});
</script>

<script>
export default {
  name: 'MakerIndex',
  components: {
  },
  data: function () {
    return {

    }
  },
  created: function () {

  },
  mounted() {



  },
  methods: {

  },
  computed: {
    // weburl () {
    //     return this.$store.state.weburl;
    // },
    // srcurl: function () {
    //     return this.$store.state.srcurl;
    // }
  }

}

</script>
<style lang="less" scoped>
.loader {
  width: 100vw;
  text-align: center;
  margin-top: 10px;
}
</style>
<style lang="less">
.model-switch-dropdown {
  width: 400px !important;
  min-width: 400px !important;

  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
    background: rgba(39, 173, 149, 0.14);
  }

  .model_option {
    display: flex;
    flex-direction: column;
    gap: 2px;
    line-height: 1.25;
  }

  .model_option_name {
    color: #1f2d3d;
    font-size: 14px;
    font-weight: 600;
  }

  .model_option_desc {
    color: #7a8699;
    font-size: 12px;
  }
}

/* 强覆盖：修复模型选择已选文字/箭头仍为黑色 */
.header .model_switch.ant-select {
  height: 32px;
}

.header .model_switch.ant-select .ant-select-arrow,
:where(.css-dev-only-do-not-override-1quwnoo).ant-select .ant-select-arrow {
  inset-inline-end: 22px !important;
}

.header .model_switch.ant-select .ant-select-selector {
  width: 100% !important;
  background: transparent !important;
  border: 1px solid rgba(255,255,255,0.45) !important;
  border-radius: 16px !important;
  color: #ffffff !important;
  height: 32px !important;
  min-height: 32px !important;
  line-height: 30px !important;
  padding: 0 5px 0 12px !important;
  box-sizing: border-box !important;
}

.header .model_switch.ant-select .ant-select-selection-item,
.header .model_switch.ant-select .ant-select-selection-placeholder,
.header .model_switch.ant-select .ant-select-selection-search-input {
  color: #ffffff !important;
  -webkit-text-fill-color: #ffffff !important;
  line-height: 30px !important;
}

.header .model_switch.ant-select .ant-select-selection-item {
  line-height: 30px !important;
}

.header .model_switch.ant-select .ant-select-arrow,
.header .model_switch.ant-select .ant-select-arrow .anticon,
.header .model_switch.ant-select .ant-select-arrow svg,
.header .model_switch.ant-select.ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selector::after {
  color: #ffffff !important;
  fill: #ffffff !important;
}

@media (min-width: 1601px) and (max-width: 1920px) {
  .operation {
    height: 90px !important;
  }
}

@media (min-width: 1921px) and (max-width: 2800px) {
  .operation {
    height: 105px !important;
  }
}

@media (min-width: 2801px) and (max-width: 3840px) {
  .operation {
    height: 115px !important;
  }
}

@media (min-width: 3841px) and (max-width: 7680px) {
  .operation {
    height: 125px !important;
  }
}

// .editor::-webkit-scrollbar {
//     width: 3px;
// }


// ::-webkit-scrollbar-thumb {
//     border-radius: 3px;
//     background-color: hsla(0, 17%, 91%, .4);
//     box-shadow: inset 0 0 6px 0 rgba(0, 0, 0, .3);
//     cursor: pointer;
// }
// ::-webkit-scrollbar-track {
//     border-radius: 3px;
//     box-shadow: inset 0 0 6px 0 rgba(0, 0, 0, .1);
// }


/* 关键修复：强制继承高度 */
html,
body,
#app {
  height: 100%;
  margin: 0;
}

.header::selection {
  color: #27ad95 !important;
  background: #fff !important;
}
//选中
.makeBody::selection {
  color: #fff;
  background: #27ad95;
}
.operation::selection {
  color: #fff;
  background: #27ad95;
}

//整个滚动条
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

//滚动条的条
::-webkit-scrollbar-thumb {
  // background: rgba(0, 0, 0, 0.2);
  background-color: rgba(236, 228, 228, 0.4);
  box-shadow: inset 0 0 6px 0 rgba(0, 0, 0, .3);
  border-radius: 3px;
  cursor: pointer;
}

//滚动条的背景
::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 3px;
  box-shadow: inset 0 0 6px 0 rgba(0, 0, 0, .1);
}

//滚动条的上下箭头和条
::-webkit-scrollbar-button {
  display: none;
}

//滚动条的条上悬停
::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.35);
}

.make {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
}

.header {
  height: 52px;
  display: block;
  background: #27ad95;
  // background: #202a29;
  display: flex;
  flex-direction: row;
  font-size: 20px;
  // line-height: 52px;
  color: #ffffff;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;

  .logo {
    margin: 0 20px;
    line-height: 52px;
  }

  .editName {
    display: flex;
    color: #fff;
    width: 220px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    span {
      max-width: 200px;
      overflow: hidden;
      text-wrap: nowrap;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .save_and_user {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    .header_action_btn {
      height: 32px;
      border-radius: 16px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      font-size: 14px;
      line-height: 1;
      transition: all .2s;
      position: relative;
    }

    .model_switch {
      width: 220px;
      min-width: 220px;
      height: 32px;
      margin-right: 12px;
      vertical-align: middle;

      :deep(.ant-select-selector) {
        width: 100%;
        border: 1px solid rgba(255,255,255,0.45) !important;
        border-radius: 16px !important;
        min-height: 32px;
        height: 32px;
        line-height: 30px;
        box-sizing: border-box;
        padding: 0 5px 0 12px !important;
        background: transparent;
        box-shadow: none !important;
      }

      :deep(.ant-select-selection-item),
      :deep(.ant-select-selection-placeholder) {
        color: #ffffff !important;
        font-size: 14px;
        line-height: 30px !important;
      }

      :deep(.ant-select-arrow),
      :deep(.ant-select-arrow .anticon),
      :deep(.ant-select-arrow svg),
      :deep(.ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selector::after) {
        color: #ffffff !important;
        fill: #ffffff !important;
      }
    }

    .save_draft_btn {
      width: 100px;
      min-width: 100px;
      margin-right: 12px;
      color: #ffffff;
      border: 1px solid rgba(255,255,255,0.45);
      justify-content: center;
      cursor: pointer;
      &:hover {
        background: rgba(255,255,255,0.22);
      }
    }

    .user {
      width: 80px;
      min-width: 80px;
      margin: 0 20px 0 0;
      color: #ffffff;
      border: 1px solid rgba(255,255,255,0.45);
      cursor: pointer;
      &:hover {
        background: rgba(255,255,255,0.12);
      }
      .user_text {
        line-height: 1;
      }
      .user_dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #52c41a;
        box-shadow: 0 0 0 2px rgba(82,196,26,.22);
      }
    }

  }
}

.operation {
  // height: 100px;
  display: block;
  // background: #f9fafc;
  // border: 1px solid #f1f2f4;
  display: flex;
  flex-direction: row;
  align-items: center;

  .partingLine {
    width: 1px;
    min-width: 1px;
    height: 40px;
    background-color: #e4e9ed;
  }

  .pause_group {
    display: flex;
    align-items: flex-start;
    gap: 6px;
  }

  .pause_main {
    margin-right: 0 !important;
  }

  .pause_shortcuts {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-top: 10px;
    flex-wrap: nowrap;
    height: 55px;
  }

  .pause_shortcut_btn {
    box-sizing: initial;
    width: 36px;
    height: 18px;
    border-radius: 3px;
    border: 1px solid #e4e9ed;
    text-align: center;
    line-height: 18px;
    color: #1b2337;
    font-size: 9px;
    cursor: pointer;
  }

  .pause_shortcut_btn:hover {
    background: #e8f7f3;
    border-color: #27ad95;
  }

  .btn_box {
    // width: 80px;
    margin: 5px 20px 15px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    span {
      // max-width: 70px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
    }
    .backmusic {
      width: 70px;
    }
    .remove_backmusic {
      position: absolute;
      width: 12px;
      height: 12px;
      top: 30px;
      right: 5px;
      z-index: 2;
      cursor: pointer;
      box-sizing: border-box;
      color: #9c9c9c;
      font-size: 10px;
    }
  }

  .operation_icon {
    margin: 10px 10px 5px 10px;
    text-align: center;
    font-size: 30px;
    width: 30px;
    color: #27ad95;
    // fill: #1a91ff;
  }
  .light_orange {
    color: #ffa963;

  }
  .light_orange2 {
    color: #ff7a63;

  }
  .light_blue {
    color: #32b7fc;
  }


  .duoyin_divider {
    height: 1px;
    margin: 8px 0;
    background: rgba(255,255,255,0.25);
  }

  .duoyin_custom {
    font-weight: 600;
    color: #fff7e6;
  }

  .selectorContainer {
    padding: 10px;
    background-color: #ff8560;
    position: absolute;
    border-radius: 10px;
    text-align: center;
    color: #fff;
    top: 90px;
    z-index: 99;
    width: 100px;
  }
}
.disabled {
  // color: #5d5d5d;
  cursor: help !important;
}
.makeBody {
  width: 100%;
  flex: 1;
  display: flex;
  background: rgb(255, 255, 255);
  min-height: 1rem;
}

.make_left {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
  /* padding: 16px; */
  background: rgb(255, 255, 255);
  // border: 1px solid #f1f2f4;
  border-right: 0px;
}

.editor {
  flex: 1;
  // border-radius: 20px;
  // border: 1px solid #f1f2f4;
  text-align: left;
  overflow-y: auto;
  border-right: 0px;

  border-radius: 20px;
  background: #f5f5f5;
  margin: 0px 10px;

  .tts-mark-editor {
    display: block;
    outline: 0;
    height: calc(100% - 40px);

    box-sizing: border-box;
    // ----------------------------
    width: calc(100%);

    // border: 1px solid #27ad95;

    background: #f5f5f5;
    padding: 0px 36px;
    margin: 20px 0px;
    position: relative;
    line-height: 222%;
    border-right: 0px;

    overflow: auto;
    min-height: 1em;


  }

  .tts-mark-editor {
    caret-color: #27ad95;
    word-break: break-word;
  }

  .tts-mark-editor[empty=true]:after {
    // width: 100%;
    content: attr(data-placeholder);
    font-weight: 400;
    font-size: 15px;
    color: rgba(27, 35, 55, .48);
    line-height: 222%;
    position: absolute;
    top: -36px;
    transform: translateY(100%);
    -webkit-transform: translateY(100%);
    -moz-transform: translateY(100%);
    -o-transform: translateY(100%);
  }

  .tts-content-paragraph,
  .tts-lrc {
    margin: 0 0 0 0;
    // font-size: 15px !important;
    font-weight: 400;
    color: #000;
    padding-top: 0;
    line-height: 222%;
  }

  .tts-mark-editor-preview > br {
    content: "";
    display: block;
    margin: 0 0 10px 0;
    line-height: 0;
  }
  .tts-mark-editor-preview > .activeing {
    background: #e8fffa;
    color: #000;
  }

  .tts-mark-editor-preview > .active {
    // background: #27ad95 !important;
    // color: #fff !important;
    background: #fff !important;
    color: #27ad95 !important;
  }

  .tts-mark-editor-preview > .tts-lrc {
    display: inline;
    margin: 0;
    padding-top: 0;
    line-height: 222%;
  }

  .tts-mark-editor-preview > br {
    display: block;
  }
  // .multiple-speaker-lrc {
  //   word-wrap: break-word;
  // }

  .tts-mark-point {
    // display: inline-block;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
    color: #fff;
    padding: 0 5px;
    cursor: pointer;
    margin: 0 2px;
    line-height: 24px;
    font: inherit;
  }

  .tts-mark-point:after {
    content: attr(data-label);
    font-size: 11px;
  }

  .tts-mark-point.tts-mark-breath {
    background: #7d78ef;
    line-height: 16px;
    padding: 0 5px;
  }

  .tts-mark-point.tts-mark-pause {
    background: #7d78ef;
    line-height: 16px;
    padding: 0 5px;
  }

  .tts-mark-point.tts-mark-pause:after {
    font-weight: 500;
    font-size: 11px;
    line-height: 20px;
  }

  .tts-mark-point.tts-mark-continuity {
    background: #7ec143;
    line-height: 16px;
    padding: 0 5px;
  }

  .tts-mark-point.tts-mark-continuity:after {
    font-weight: 500;
    font-size: 11px;
    line-height: 20px;
  }

  .tts-mark-point.tts-mark-pinyin {
    margin: 0;
    padding: 0;
    user-select: auto;
  }

  .tts-mark-point.tts-mark-pinyin:after {
    color: #ff8560;
    font-size: 15px;
    // font-weight: 600;
  }
}

/* Webkit 定制 */
.tts-mark-editor::-webkit-scrollbar {
  width: 3px;
}
.speakerList::-webkit-scrollbar {
  width: 3px;
}
.music_library::-webkit-scrollbar {
  width: 3px;
}

.core {
  width: 100%;
  height: 80px;
  font-size: 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;

  .core_btn {
    width: 200px;
    height: 50px;
    margin: 15px;
    border-radius: 30px;
    cursor: pointer;
    border: 2px solid #f1f2f4;
    line-height: 50px;
    min-width: 100px;
  }

  .complete {
    background: #27ad95;
    color: #ffffff;
  }

  .trial {
    border: 2px solid #27ad95;
    background: #ffffff;
    color: #27ad95;
  }

  .word_count {
    margin: 15px;
    line-height: 50px;
    color: #27ad95;
    font-size: 14px;
    min-width: 150px;
  }
}



.mini_make_right {
  display: block;
  width: 150px;
  min-width: 150px;
  overflow: auto;
  background: rgb(255, 255, 255);
  // border: 1px solid #f1f2f4;
  user-select: none;
  .speakerSelect {
    height: calc(100% - 15px);
    background: #f5f5f5;
    border-radius: 20px;
    border: 1px solid #f1f2f4;
    margin: 0 10px;
    .speaker_header {
      height: 50px;
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: nowrap;
      margin: 10px 0;
      .retractBtn {
        cursor: pointer;
        // margin: 0 20px;
        width: 50px;
        height: 50px;
        line-height: 50px;
        font-size: 20px;
      }
      .mini_tip {
        flex: 1;
        text-align: left;
        line-height: 50px;
        font-size: 20px;
        cursor: pointer;
      }
    }
    .speaker_main {
      display: flex;
      flex-direction: column;
      margin: 0 12px;
      background: #fff;
      border-radius: 10px;
      height: calc(100% - 85px);

      .speakerList {
        display: flex;
        flex: 1;
        flex-wrap: nowrap;
        flex-direction: column;
        padding: 5px;
        // margin-top: 10px;
        border-radius: 10px;
        overflow-x: auto;
        align-items: center;
        justify-content: flex-start;

        .speaker {
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;
          align-items: center;
          .active {
            border: 1px solid #27ad95 !important;
            box-shadow: 0px 0px 6px 0px skyblue;
          }
          .speaker_img {
            width: 70px;
            height: 70px;
            border-radius: 50px;
            border: 1px solid #f1f2f4;
          }
          .speaker_img > img{
            width: 70px;
            height: 70px;
            border-radius: 50px;
          }
          .speaker_name {
            width: 90px;
            margin: 5px 0px 15px 0px;
            font-size: 18px;
            font-weight: 600;
            line-height: 30px;
            font-style: normal;

            overflow: hidden;
            text-wrap: nowrap;
            white-space: nowrap;
            text-overflow: ellipsis;

          }
        }
      }
    }
  }
}

.make_right {
  display: block;
  width: 600px;
  min-width: 600px;
  overflow: auto;
  background: rgb(255, 255, 255);
  // border: 1px solid #f1f2f4;
  user-select: none;
  /* border-left: 1px solid rgb(240, 240, 240); */
  /* padding: 16px; */

  .speakerSelect {
    height: calc(100% - 15px);
    background: #f5f5f5;
    border-radius: 20px;
    border: 1px solid #f1f2f4;
    margin: 0 10px;
    // padding-bottom: 10px;
    .speaker_header {
      height: 50px;
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: nowrap;
      margin: 10px 0;
      // border: 1px solid #f1f2f4;
      .selectTxt {
        flex: 1;
        text-align: left;
        height: 50px;
        line-height: 50px;
        font-size: 20px;
        padding: 0 20px;

      }
      .retractBtn {
        cursor: pointer;
        // margin: 0 20px;
        width: 50px;
        height: 50px;
        line-height: 50px;
        font-size: 20px;
      }
    }
    .speaker_main {
      display: flex;
      flex-direction: column;
      margin: 0 16px;
      background: #fff;
      border-radius: 10px;
      height: calc(100% - 85px);
      .tabs {
        height: 50px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        .tab {
          // padding: 0 30px;
          flex: 1;
          text-align: center;
          line-height: 50px;
          // border: 1px solid #f1f2f4;
          width: auto;
          cursor: pointer !important;
          font-size: 16px;
          font-weight: 500;
        }
        .active {
          color: #27ad95;
          // border-bottom: 3px solid #27ad95;
          cursor: pointer !important;;
        }
        .active::after {
          position: relative;
          content: "";
          display: block;
          width: 60%;
          left: 20%;
          height: 4px;
          background: #27ad95;
          border-radius: 4px;
        }
      }
      .speakerList {
        display: flex;
        flex: 1;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;
        align-content: flex-start;
        padding: 16px;
        margin-top: 10px;
        border-radius: 10px;
        overflow: auto;

        .speaker_empty {
          width: 100%;
          color: #999;
          text-align: center;
          padding: 32px 0;
          font-size: 16px;
        }

        .active {
          border: 1px solid #27ad95 !important;
          box-shadow: 0px 0px 6px 0px skyblue;
          // width: 246px !important;
          // max-width: 246px !important;
          // height: 126px !important;
        }
        .speaker {
          width: 250px;
          max-width: 250px;
          height: 130px;
          cursor: pointer;
          border-radius: 10px;
          border: 1px solid #f1f2f4;
          margin-bottom: 10px;
          background: #f2f6f5cc;
          .speaker_top {
            display: flex;
            flex-direction: row;
            position: relative;
            .favorite_icon {
              position: absolute;
              left: 8px;
              top: 8px;
              width: 24px;
              height: 24px;
              border-radius: 50%;
              background: rgba(255, 255, 255, 0.95);
              color: #bfbfbf;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 14px;
              z-index: 2;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
            }
            .favorite_icon.active {
              color: #f5a623;
            }
            .speaker_img {
              width: 70px;
              height: 70px;
              margin: 10px 10px 0px 10px;
            }
            .speaker_img > img{
              width: 70px;
              height: 70px;
              border-radius: 50px;
            }
            .speaker_intro {
              text-align: left;
              .speaker_name {
                width: 135px;
                margin-top: 15px;
                font-size: 18px;
                font-weight: 600;
                line-height: 30px;
                font-style: normal;

                overflow: hidden;
                text-wrap: nowrap;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              .speaker_tag {
                width: 155px;
                max-width: 155px;
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
                font-style: normal;

                overflow: hidden;
                text-wrap: nowrap;
                white-space: nowrap;
                text-overflow: ellipsis;

              }
            }
            .delete_icon {
              position: relative;
              right: 23px;
              top: 3px;
              width: 25px;
              height: 30px;
              font-size: 20px;
              color: #f16e78b0;
            }
          }
          .speaker_bottom {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            .speaker_info {
              width: 90px;
              height: 50px;
              font-size: 10px;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;

              .speaker_info_item {
                margin: 5px;
                color: #868686;

                text-wrap: nowrap;
                white-space: nowrap;
              }
            }

            .speaker_btn {
              width: 170px;
              text-align: center;
              line-height: 30px;
              cursor: pointer;
              // border-top: 1px solid #f1f2f4;

              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: space-evenly;
              .speaker_btn_item {
                // width: 60px;
                color: #27ad95;
                padding: 0 15px;
                height: 30px;
                border: 1px solid #27ad95;
                border-radius: 15px;
              }
              .playerSpeaker {
                background: linear-gradient(90deg, #27ad9533 0%, #fff 0%);
              }
              .setting {
                background-color: #27ad95;
                color: #fff;
                // cursor: help !important;
              }
            }
          }
        }
        .custom_speaker_btn {
          width: 250px;
          max-width: 250px;
          height: 130px;
          cursor: pointer;
          border-radius: 10px;
          border: 1px dashed #bbbbbb;
          margin-bottom: 10px;
          .custom_tip {
            font-size: 20px;
            color: #9c9c9c;
            margin: 0;
          }
        }
      }
    }
  }
  .settingSpeaker {

    height: calc(100% - 15px);
    background: #f5f5f5;
    border-radius: 20px;
    border: 1px solid #f1f2f4;
    margin: 0 10px;
    .speaker_header {
      height: 50px;
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: nowrap;
      margin: 10px 0;
      // border: 1px solid #f1f2f4;
      .mini_tip {
        flex: 1;
        text-align: left;
        line-height: 50px;
        font-size: 20px;
        cursor: pointer;
      }
      .retractBtn {
        cursor: pointer;
        // margin: 0 20px;
        width: 50px;
        height: 50px;
        line-height: 50px;
        font-size: 20px;
      }
    }
    .setting_main {
      display: flex;
      flex-direction: column;
      margin: 0 12px;
      background: #fff;
      border-radius: 10px;
      height: calc(100% - 85px);
      .speaker {
        height: 130px;
        cursor: pointer;
        border-radius: 10px;
        margin-bottom: 30px;
        .speaker_top {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          margin: 30px;
          .speaker_img {
            height: 100px;

          }
          .speaker_img > img{
            width: 100px;
            height: 100px;
            border-radius: 50px;
          }
          .speaker_intro {
            margin-left: 30px;
            text-align: left;
            width: calc(100% - 130px);
            .speaker_name {
              font-size: 20px;
              font-weight: 600;
              line-height: 40px;
              font-style: normal;

              overflow: hidden;
              text-wrap: nowrap;
              white-space: nowrap;
              text-overflow: ellipsis;

              &.speaker_name_editable {
                display: flex;
                align-items: center;
                gap: 8px;
                padding: 0 10px;
                border-radius: 10px;
                background: #f5f5f5;
                cursor: pointer;

                span {
                  flex: 1;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  color: #1f2d3d;
                }

                .ant-input {
                  height: 40px;
                  font-size: 20px;
                  font-weight: 600;
                  line-height: 40px;
                  background: transparent;
                }

                :deep(.ant-input-affix-wrapper),
                :deep(.ant-input) {
                  flex: 1 1 auto;
                  background: transparent;
                  box-shadow: none;
                }

                :deep(.anticon) {
                  flex: 0 0 10%;
                  min-width: 18px;
                  text-align: right;
                }
              }
            }
            .speaker_tag {
              font-size: 16px;
              font-weight: 400;
              line-height: 30px;
              font-style: normal;
              color: #9c9c9c;
              overflow: hidden;
              text-wrap: nowrap;
              white-space: nowrap;
              text-overflow: ellipsis;

            }
          }
        }
      }
      .speaker_setting_item {
        min-height: 100px;
        margin: 0px 30px 20px 30px;
        .setting_item_title {
          width: 100%;
          height: 30px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          font-size: 16px;
          .setting_item_name {
            font-size: 16px;
            font-weight: 400;
            line-height: 50px;
            font-style: normal;
            color: #000000;
          }
          .setting_item_value {
            font-size: 16px;
            font-weight: 400;
            line-height: 50px;
            font-style: normal;
            color: #000000;
          }
        }
      }
    }
  }
}

.custom_btn {
  width: 160px;
  height: 45px;
  margin: 15px;
  border-radius: 30px;
  cursor: pointer;
  min-width: 100px;
}

.customCancel {
  border: 2px solid #27ad95;
  background: #ffffff;
  color: #27ad95;
}
.customUpload {
  background: #27ad95;
  color: #ffffff;
  box-shadow: 0px 0px;
}
.uploadContent {
  margin: 36px 36px 10px 36px;
  width: 400px;
  max-width: 400px;

  cursor: pointer;
  text-align: center;
  border: 1px dashed #bbbbbb;
  .custom_tip {
    font-size: 20px;
    color: #454545;
    margin: 0px;
  }
  .custom_tip2 {
    font-size: 16px;
    color: #9c9c9c;
    margin: 5px;
  }
  .custom_tip3 {
    font-size: 14px;
    color: #9c9c9c;
    margin: 5px;
  }
}
.custom_speaker {
  height: 180px;
}
.import_txtfile {
  height: 200px;
}
.custom_speaker_optimize {
  margin-top: 20px;
  text-align: center;

  .custom_speaker_noise_reduction {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-size: 14px;
    color: #454545;
  }
}
.music_library {
  height: 420px;
  width: calc(100% + 6px);
  grid-column-gap: 12px;
  overflow-x: auto;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  align-content: flex-start;
  padding: 6px 0px 6px 6px;
  .active {
    border: 1px solid #27ad95 !important;
    box-shadow: 0px 0px 6px 0px skyblue;
  }
}
.backmusic_footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  .bgvolume {
    width: 35%;
  }
  .setting_item_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    flex-wrap: nowrap;
  }
}

.music_library_item {
  width: 294px;
  height: 90px;
  margin-bottom: 12px;
  border-radius: 12px;
  background: #f2f6f5cc;
  display: flex;
  align-items: center;
  cursor: pointer;
  box-sizing: border-box;
  position: relative;
  .player_icon {
    width: 30px;
    height: 30px;
    margin: 0 20px;
    font-size: 20px;
    border-radius: 30px;
    color: #27ad95;
    border: 2px solid #27ad95;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .music_info {
    text-align: left;
    font-weight: 400;
    .music_name {
      font-size: 16px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 210px;
    }
    .music_duration {
      font-size: 12px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 210px;
      color: rgba(27, 35, 55, .32);
    }
  }
  .delete_icon {
    position: absolute;
    right: 6px;
    width: 20px;
    height: 20px;
    line-height: 0;
    cursor: pointer;
    bottom: 6px;
    color: #9c9c9c;
  }
}

.make_loading_modal {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.18);
  pointer-events: all;
}

.make_loading_modal_inner {
  min-width: 220px;
  padding: 24px 28px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.make_loading_modal_text {
  margin-top: 14px;
  color: #1f2d3d;
  font-size: 14px;
  line-height: 22px;
}

.fileSettingOpen {
  .ant-modal-content {
    padding: 0px;
  }
}

.login_modal_body {
  padding-top: 8px;
}

.model_tip_modal {
  color: #1f2d3d;
  font-size: 14px;
  line-height: 22px;

  .model_tip_loading,
  .model_tip_empty {
    padding: 12px 0;
    color: #6b7280;
  }

  .model_tip_model_name {
    margin-bottom: 10px;
    font-weight: 600;
    color: #27ad95;
  }

  .model_tip_section_title {
    margin: 12px 0 6px;
    font-weight: 600;
    color: #1f2d3d;
  }

  .model_tip_list {
    margin: 0;
    padding-left: 18px;
  }

  .model_tip_list li {
    margin-bottom: 8px;
  }
}
// .operation_icon :deep(.anticon) {
//   margin-right: 6px;
//   font-size: 24px;
//   fill: "#27ad95";
// }

</style>
